'use client'

import cn from 'classnames'

type IconProps = {
  color: 'primary' | 'secondary' | 'success' | 'danger'
  size: 'xxsmall' | 'xsmall' | 'small' | 'base' | 'medium' | 'large' | 'xlarge'
  className?: string
}

const classnames = (props: IconProps) =>
  cn(
    {
      'h-2.5 w-2.5': props.size === 'xxsmall',
      'h-3.5 w-3.5': props.size === 'xsmall',
      'h-4 w-4': props.size === 'small',
      'h-5 w-5': props.size === 'base',
      'h-11 w-11 sm:h-[50px] sm:w-[50px]': props.size === 'large',
      'h-16 w-16 sm:h-20 sm:w-20': props.size === 'xlarge',
      // 'text-primary': props.color === 'primary',
      // 'text-foreground-secondary': props.color === 'secondary',
      // 'text-green-600': props.color === 'success',
      // 'text-red-600': props.color === 'danger',
    },
    props.className,
    'duration-200 ease-in-out'
  )

export const Icon = {
  Envelop: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 15"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M1.02051 4.33952L8.03384 9.01507C8.32598 9.20999 8.66931 9.31401 9.02051 9.31401C9.3717 9.31401 9.71503 9.20999 10.0072 9.01507L17.0205 4.33952M2.79829 14.1173H15.2427C15.7142 14.1173 16.1664 13.93 16.4998 13.5966C16.8332 13.2632 17.0205 12.811 17.0205 12.3395V3.45063C17.0205 2.97913 16.8332 2.52695 16.4998 2.19355C16.1664 1.86015 15.7142 1.67285 15.2427 1.67285H2.79829C2.32679 1.67285 1.8746 1.86015 1.54121 2.19355C1.20781 2.52695 1.02051 2.97913 1.02051 3.45063V12.3395C1.02051 12.811 1.20781 13.2632 1.54121 13.5966C1.8746 13.93 2.32679 14.1173 2.79829 14.1173Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Phone: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M1.02051 2.83002C1.02051 2.35853 1.20781 1.90634 1.54121 1.57295C1.8746 1.23955 2.32679 1.05225 2.79829 1.05225H5.71384C5.90032 1.05239 6.08204 1.11118 6.23327 1.22029C6.3845 1.3294 6.49758 1.48332 6.55651 1.66025L7.88806 5.65402C7.95553 5.85699 7.94755 6.07748 7.86559 6.27504C7.78363 6.4726 7.63318 6.63398 7.44184 6.72958L5.43562 7.73402C6.41901 9.9105 8.16225 11.6537 10.3387 12.6371L11.3432 10.6309C11.4388 10.4396 11.6002 10.2891 11.7977 10.2072C11.9953 10.1252 12.2158 10.1172 12.4187 10.1847L16.4125 11.5162C16.5896 11.5752 16.7436 11.6884 16.8527 11.8398C16.9619 11.9913 17.0206 12.1732 17.0205 12.3598V15.2745C17.0205 15.746 16.8332 16.1981 16.4998 16.5315C16.1664 16.8649 15.7142 17.0522 15.2427 17.0522H14.3538C6.99029 17.0522 1.02051 11.0825 1.02051 3.71891V2.83002Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChevronDown: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="57 35.171 26 16.043"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"
      ></path>
    </svg>
  ),
  ChevronRight: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6 9"
      className={classnames(props)}
      fill="none"
    >
      <path
        fillRule="evenodd"
        fill="currentColor"
        clipRule="evenodd"
        d="M0.972034 8.17276C0.815797 8.01648 0.728027 7.80454 0.728027 7.58356C0.728027 7.36257 0.815797 7.15063 0.972034 6.99435L3.7164 4.24998L0.972034 1.50562C0.820224 1.34844 0.736223 1.13793 0.738122 0.919413C0.74002 0.7009 0.827668 0.491875 0.982185 0.337357C1.1367 0.182839 1.34573 0.095192 1.56424 0.0932932C1.78275 0.0913944 1.99327 0.175396 2.15045 0.327205L5.48402 3.66078C5.64026 3.81706 5.72803 4.029 5.72803 4.24998C5.72803 4.47097 5.64026 4.68291 5.48402 4.83919L2.15045 8.17276C1.99417 8.329 1.78223 8.41677 1.56124 8.41677C1.34026 8.41677 1.12832 8.329 0.972034 8.17276Z"
      />
    </svg>
  ),
  MobileMenu: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 16"
      className={classnames(props)}
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.56355C0 1.22255 0.135459 0.895527 0.376577 0.654409C0.617695 0.413291 0.944722 0.277832 1.28571 0.277832H16.7143C17.0553 0.277832 17.3823 0.413291 17.6234 0.654409C17.8645 0.895527 18 1.22255 18 1.56355C18 1.90454 17.8645 2.23157 17.6234 2.47268C17.3823 2.7138 17.0553 2.84926 16.7143 2.84926H1.28571C0.944722 2.84926 0.617695 2.7138 0.376577 2.47268C0.135459 2.23157 0 1.90454 0 1.56355ZM0 7.99212C0 7.65112 0.135459 7.3241 0.376577 7.08298C0.617695 6.84186 0.944722 6.7064 1.28571 6.7064H16.7143C17.0553 6.7064 17.3823 6.84186 17.6234 7.08298C17.8645 7.3241 18 7.65112 18 7.99212C18 8.33311 17.8645 8.66014 17.6234 8.90125C17.3823 9.14237 17.0553 9.27783 16.7143 9.27783H1.28571C0.944722 9.27783 0.617695 9.14237 0.376577 8.90125C0.135459 8.66014 0 8.33311 0 7.99212ZM0 14.4207C0 14.0797 0.135459 13.7527 0.376577 13.5116C0.617695 13.2704 0.944722 13.135 1.28571 13.135H16.7143C17.0553 13.135 17.3823 13.2704 17.6234 13.5116C17.8645 13.7527 18 14.0797 18 14.4207C18 14.7617 17.8645 15.0887 17.6234 15.3298C17.3823 15.5709 17.0553 15.7064 16.7143 15.7064H1.28571C0.944722 15.7064 0.617695 15.5709 0.376577 15.3298C0.135459 15.0887 0 14.7617 0 14.4207Z"
      />
    </svg>
  ),
  XMark: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 16"
      className={classnames(props)}
      fill="none"
    >
      <path
        d="M1.0299 1.57548L12.3436 14.4978M12.3436 1.57548L1.0299 14.4978"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LongArrowRight: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54 43"
      className={classnames(props)}
      fill="none"
    >
      <path
        d="M32.9921 2.05566L52.4365 21.5001M52.4365 21.5001L32.9921 40.9445M52.4365 21.5001H2.43652"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Quote: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      viewBox="0 0 41 40"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(props)}
    >
      <path d="M8.66312 15.4167C8.66312 12.4251 11.0882 10 14.0798 10H14.9131C15.6035 10 16.1631 9.44035 16.1631 8.75C16.1631 8.05965 15.6035 7.5 14.9131 7.5H14.0798C9.70753 7.5 6.16312 11.0444 6.16312 15.4167V28.75C6.16312 30.821 7.84205 32.5 9.91312 32.5H14.9131C16.9842 32.5 18.6631 30.821 18.6631 28.75V22.5C18.6631 20.429 16.9842 18.75 14.9131 18.75H8.66312V15.4167Z" />
      <path d="M24.9131 15.4167C24.9131 12.4251 27.3383 10 30.3298 10H31.1631C31.8534 10 32.4131 9.44035 32.4131 8.75C32.4131 8.05965 31.8534 7.5 31.1631 7.5H30.3298C25.9574 7.5 22.4131 11.0444 22.4131 15.4167V28.75C22.4131 30.821 24.0921 32.5 26.1631 32.5H31.1631C33.2341 32.5 34.9131 30.821 34.9131 28.75V22.5C34.9131 20.429 33.2341 18.75 31.1631 18.75H24.9131V15.4167Z" />
    </svg>
  ),
  CheckMark: (props: IconProps) => (
    <svg
      aria-hidden="true"
      className={classnames(props)}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
    </svg>
  ),
  Plus: (props: IconProps) => (
    <svg
      aria-hidden="true"
      className={classnames(props)}
      viewBox="0 0 448 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
    </svg>
  ),
  Minus: (props: IconProps) => (
    <svg
      aria-hidden="true"
      className={classnames(props)}
      viewBox="0 0 448 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
    </svg>
  ),
  FaceBook: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      viewBox="0 0 448 448"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path
        d="M23 45C23 33.9543 31.9543 25 43 25H405C416.046 25 425 33.9543 425 45V411C425 422.046 416.046 431 405 431H43C31.9543 431 23 422.046 23 411V45Z"
        fill="white"
      ></path>
      <path d="M185 431H263V448H185V431Z" fill="white"></path>
      <path d="M400 0H48C35.2696 0 23.0606 5.05713 14.0589 14.0589C5.05713 23.0606 0 35.2696 0 48V400C0 412.73 5.05713 424.939 14.0589 433.941C23.0606 442.943 35.2696 448 48 448H185.25V295.69H122.25V224H185.25V169.36C185.25 107.21 222.25 72.88 278.92 72.88C306.06 72.88 334.44 77.72 334.44 77.72V138.72H303.17C272.36 138.72 262.75 157.84 262.75 177.45V224H331.53L320.53 295.69H262.75V448H400C412.73 448 424.939 442.943 433.941 433.941C442.943 424.939 448 412.73 448 400V48C448 35.2696 442.943 23.0606 433.941 14.0589C424.939 5.05713 412.73 0 400 0Z"></path>
    </svg>
  ),
  Pinterest: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      viewBox="0 0 448 448"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(props)}
      fill="currentColor"
    >
      <path
        d="M5 54C5 26.3858 27.3858 4 55 4H392C419.614 4 442 26.3858 442 54V393C442 420.614 419.614 443 392 443H55C27.3858 443 5 420.614 5 393V54Z"
        fill="white"
      ></path>
      <path d="M134 443H157V448H134V443Z" fill="white"></path>
      <path d="M448 48V400C448 426.5 426.5 448 400 448H154.4C164.2 431.6 176.8 408 181.8 388.7C184.8 377.2 197.1 330.3 197.1 330.3C205.1 345.6 228.5 358.5 253.4 358.5C327.5 358.5 380.8 290.4 380.8 205.8C380.8 124.7 314.6 64 229.4 64C123.4 64 67.2 135.1 67.2 212.6C67.2 248.6 86.4 293.4 117 307.7C121.7 309.9 124.1 308.9 125.2 304.4C126 301 130.2 284.3 132 276.6C132.6 274.1 132.3 272 130.3 269.6C120.2 257.3 112 234.7 112 213.6C112 159.4 153 107 222.9 107C283.2 107 325.5 148.1 325.5 206.9C325.5 273.3 292 319.3 248.3 319.3C224.2 319.3 206.2 299.4 211.9 274.9C218.8 245.7 232.2 214.2 232.2 193.1C232.2 140.1 156.7 147.4 156.7 218.1C156.7 239.8 164 254.6 164 254.6C132.6 387.4 127.9 389.1 134.4 447.2L136.6 448H48C21.5 448 0 426.5 0 400V48C0 21.5 21.5 0 48 0H400C426.5 0 448 21.5 448 48Z"></path>
    </svg>
  ),
  LinkedIn: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      viewBox="0 0 448 448"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(props)}
      fill="currentColor"
    >
      <path
        d="M391.897 7H57.1027C30.5363 7 9 28.6862 9 55.4375V392.562C9 419.314 30.5363 441 57.1027 441H391.897C418.464 441 440 419.314 440 392.562V55.4375C440 28.6862 418.464 7 391.897 7Z"
        fill="white"
      ></path>
      <path d="M416 0H31.9C14.3 0 0 14.5 0 32.3V415.7C0 433.5 14.3 448 31.9 448H416C433.6 448 448 433.5 448 415.7V32.3C448 14.5 433.6 0 416 0ZM69 384V170.2H135.5V384H69ZM102.2 141C80.9 141 63.7 123.7 63.7 102.5C63.7 81.3 80.9 64 102.2 64C123.4 64 140.7 81.3 140.7 102.5C140.7 123.8 123.5 141 102.2 141ZM384.3 384H317.9V280C317.9 255.2 317.4 223.3 283.4 223.3C248.8 223.3 243.5 250.3 243.5 278.2V384H177.1V170.2H240.8V199.4H241.7C250.6 182.6 272.3 164.9 304.6 164.9C371.8 164.9 384.3 209.2 384.3 266.8V384Z"></path>
    </svg>
  ),
  Twitter: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 32 448 448"
      className={classnames(props)}
      fill="currentColor"
    >
      <path
        d="M64 32C28.7 32 0 60.7 0 96V416C0 451.3 28.7 480 64 480H384C419.3 480 448 451.3 448 416V96C448 60.7 419.3 32 384 32H64ZM361.1 116 257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8L186.8 269.1 69.7 116H167.7L235.4 205.5 313.6 116H361.1ZM323.3 367.6 153.4 142.9H125.1L296.9 367.6H323.2Z"
        fill="#000000"
      />
    </svg>
  ),
  ErrorCircle: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(props)}
      fill="currentColor"
    >
      <path
        d="M12.0004 7.81075C12.4146 7.81075 12.7504 8.14653 12.7504 8.56075V12.7803C12.7504 13.1945 12.4146 13.5303 12.0004 13.5303C11.5861 13.5303 11.2504 13.1945 11.2504 12.7803V8.56075C11.2504 8.14653 11.5861 7.81075 12.0004 7.81075Z"
        fill="currentColor"
      ></path>
      <path
        d="M11.0994 15.3303C11.0994 14.8332 11.5023 14.4303 11.9994 14.4303C12.4965 14.4303 12.9001 14.8332 12.9001 15.3303C12.9001 15.8274 12.4972 16.2303 12.0001 16.2303C11.5031 16.2303 11.0994 15.8274 11.0994 15.3303Z"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  FileStack: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M45.9444 23.7222H7.05556M45.9444 23.7222C47.4179 23.7222 48.8309 24.3075 49.8728 25.3494C50.9147 26.3913 51.5 27.8044 51.5 29.2778V45.9444C51.5 47.4179 50.9147 48.8309 49.8728 49.8728C48.8309 50.9147 47.4179 51.5 45.9444 51.5H7.05556C5.58213 51.5 4.16905 50.9147 3.12718 49.8728C2.08532 48.8309 1.5 47.4179 1.5 45.9444V29.2778C1.5 27.8044 2.08532 26.3913 3.12718 25.3494C4.16905 24.3075 5.58213 23.7222 7.05556 23.7222M45.9444 23.7222V18.1667C45.9444 16.6932 45.3591 15.2802 44.3173 14.2383C43.2754 13.1964 41.8623 12.6111 40.3889 12.6111M7.05556 23.7222V18.1667C7.05556 16.6932 7.64087 15.2802 8.68274 14.2383C9.72461 13.1964 11.1377 12.6111 12.6111 12.6111M40.3889 12.6111V7.05556C40.3889 5.58213 39.8036 4.16905 38.7617 3.12718C37.7198 2.08532 36.3068 1.5 34.8333 1.5H18.1667C16.6932 1.5 15.2802 2.08532 14.2383 3.12718C13.1964 4.16905 12.6111 5.58213 12.6111 7.05556V12.6111M40.3889 12.6111H12.6111"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Puzzle: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M24.5769 7.05556C24.5769 5.58213 25.1172 4.16905 26.0789 3.12718C27.0407 2.08532 28.345 1.5 29.7051 1.5C31.0652 1.5 32.3696 2.08532 33.3313 3.12718C34.293 4.16905 34.8333 5.58213 34.8333 7.05556V9.83333C34.8333 10.57 35.1035 11.2766 35.5843 11.7975C36.0652 12.3185 36.7174 12.6111 37.3974 12.6111H45.0897C45.7698 12.6111 46.422 12.9038 46.9028 13.4247C47.3837 13.9456 47.6538 14.6522 47.6538 15.3889V23.7222C47.6538 24.4589 47.3837 25.1655 46.9028 25.6864C46.422 26.2073 45.7698 26.5 45.0897 26.5H42.5256C41.1656 26.5 39.8612 27.0853 38.8995 28.1272C37.9377 29.1691 37.3974 30.5821 37.3974 32.0556C37.3974 33.529 37.9377 34.9421 38.8995 35.9839C39.8612 37.0258 41.1656 37.6111 42.5256 37.6111H45.0897C45.7698 37.6111 46.422 37.9038 46.9028 38.4247C47.3837 38.9456 47.6538 39.6522 47.6538 40.3889V48.7222C47.6538 49.4589 47.3837 50.1655 46.9028 50.6864C46.422 51.2073 45.7698 51.5 45.0897 51.5H37.3974C36.7174 51.5 36.0652 51.2073 35.5843 50.6864C35.1035 50.1655 34.8333 49.4589 34.8333 48.7222V45.9444C34.8333 44.471 34.293 43.0579 33.3313 42.0161C32.3696 40.9742 31.0652 40.3889 29.7051 40.3889C28.345 40.3889 27.0407 40.9742 26.0789 42.0161C25.1172 43.0579 24.5769 44.471 24.5769 45.9444V48.7222C24.5769 49.4589 24.3068 50.1655 23.8259 50.6864C23.3451 51.2073 22.6929 51.5 22.0128 51.5H14.3205C13.6405 51.5 12.9883 51.2073 12.5074 50.6864C12.0266 50.1655 11.7564 49.4589 11.7564 48.7222V40.3889C11.7564 39.6522 11.4863 38.9456 11.0054 38.4247C10.5245 37.9038 9.87235 37.6111 9.19231 37.6111H6.6282C5.26812 37.6111 3.96374 37.0258 3.00202 35.9839C2.04029 34.9421 1.5 33.529 1.5 32.0556C1.5 30.5821 2.04029 29.1691 3.00202 28.1272C3.96374 27.0853 5.26812 26.5 6.6282 26.5H9.19231C9.87235 26.5 10.5245 26.2073 11.0054 25.6864C11.4863 25.1655 11.7564 24.4589 11.7564 23.7222V15.3889C11.7564 14.6522 12.0266 13.9456 12.5074 13.4247C12.9883 12.9038 13.6405 12.6111 14.3205 12.6111H22.0128C22.6929 12.6111 23.3451 12.3185 23.8259 11.7975C24.3068 11.2766 24.5769 10.57 24.5769 9.83333V7.05556Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PlayButton: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M34.1446 24.1881L25.264 18.2659C24.8453 17.9865 24.3585 17.8262 23.8557 17.802C23.353 17.7779 22.853 17.8908 22.4095 18.1287C21.9659 18.3666 21.5952 18.7206 21.3372 19.1528C21.0792 19.585 20.9435 20.0792 20.9446 20.5826V32.4243C20.9445 32.9271 21.081 33.4206 21.3394 33.8521C21.5978 34.2835 21.9685 34.6366 22.4119 34.8739C22.8553 35.1111 23.3548 35.2236 23.8571 35.1992C24.3594 35.1748 24.8457 35.0145 25.264 34.7354L34.1446 28.8131C34.525 28.5595 34.837 28.2158 35.0527 27.8126C35.2684 27.4095 35.3813 26.9593 35.3813 26.502C35.3813 26.0448 35.2684 25.5946 35.0527 25.1914C34.837 24.7883 34.525 24.4418 34.1446 24.1881Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5 26.5C51.5 29.783 50.8534 33.0339 49.597 36.0671C48.3406 39.1002 46.4991 41.8562 44.1777 44.1777C41.8562 46.4991 39.1002 48.3406 36.0671 49.597C33.0339 50.8534 29.783 51.5 26.5 51.5C23.217 51.5 19.9661 50.8534 16.9329 49.597C13.8998 48.3406 11.1438 46.4991 8.82233 44.1777C6.50087 41.8562 4.65938 39.1002 3.40301 36.0671C2.14664 33.0339 1.5 29.783 1.5 26.5C1.5 19.8696 4.13392 13.5107 8.82233 8.82233C13.5107 4.13392 19.8696 1.5 26.5 1.5C33.1304 1.5 39.4893 4.13392 44.1777 8.82233C48.8661 13.5107 51.5 19.8696 51.5 26.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Schedule: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M15.3889 12.6111V1.5M37.6111 12.6111V1.5M12.6111 23.7222H40.3889M7.05556 51.5H45.9444C47.4179 51.5 48.8309 50.9147 49.8728 49.8728C50.9147 48.8309 51.5 47.4179 51.5 45.9444V12.6111C51.5 11.1377 50.9147 9.72461 49.8728 8.68274C48.8309 7.64087 47.4179 7.05556 45.9444 7.05556H7.05556C5.58213 7.05556 4.16905 7.64087 3.12718 8.68274C2.08532 9.72461 1.5 11.1377 1.5 12.6111V45.9444C1.5 47.4179 2.08532 48.8309 3.12718 49.8728C4.16905 50.9147 5.58213 51.5 7.05556 51.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Display: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M20.25 40.3889L18.1667 48.7222L15.3889 51.5H37.6111L34.8333 48.7222L32.75 40.3889M1.5 29.2778H51.5M7.05556 40.3889H45.9444C47.4179 40.3889 48.8309 39.8036 49.8728 38.7617C50.9147 37.7198 51.5 36.3068 51.5 34.8333V7.05556C51.5 5.58213 50.9147 4.16905 49.8728 3.12718C48.8309 2.08532 47.4179 1.5 45.9444 1.5H7.05556C5.58213 1.5 4.16905 2.08532 3.12718 3.12718C2.08532 4.16905 1.5 5.58213 1.5 7.05556V34.8333C1.5 36.3068 2.08532 37.7198 3.12718 38.7617C4.16905 39.8036 5.58213 40.3889 7.05556 40.3889Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Grid: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M1.5 4.625C1.5 3.7962 1.82924 3.00134 2.41529 2.41529C3.00134 1.82924 3.7962 1.5 4.625 1.5H48.375C49.2038 1.5 49.9987 1.82924 50.5847 2.41529C51.1708 3.00134 51.5 3.7962 51.5 4.625V10.875C51.5 11.7038 51.1708 12.4987 50.5847 13.0847C49.9987 13.6708 49.2038 14 48.375 14H4.625C3.7962 14 3.00134 13.6708 2.41529 13.0847C1.82924 12.4987 1.5 11.7038 1.5 10.875V4.625ZM1.5 29.625C1.5 28.7962 1.82924 28.0013 2.41529 27.4153C3.00134 26.8292 3.7962 26.5 4.625 26.5H23.375C24.2038 26.5 24.9987 26.8292 25.5847 27.4153C26.1708 28.0013 26.5 28.7962 26.5 29.625V48.375C26.5 49.2038 26.1708 49.9987 25.5847 50.5847C24.9987 51.1708 24.2038 51.5 23.375 51.5H4.625C3.7962 51.5 3.00134 51.1708 2.41529 50.5847C1.82924 49.9987 1.5 49.2038 1.5 48.375V29.625ZM39 29.625C39 28.7962 39.3292 28.0013 39.9153 27.4153C40.5013 26.8292 41.2962 26.5 42.125 26.5H48.375C49.2038 26.5 49.9987 26.8292 50.5847 27.4153C51.1708 28.0013 51.5 28.7962 51.5 29.625V48.375C51.5 49.2038 51.1708 49.9987 50.5847 50.5847C49.9987 51.1708 49.2038 51.5 48.375 51.5H42.125C41.2962 51.5 40.5013 51.1708 39.9153 50.5847C39.3292 49.9987 39 49.2038 39 48.375V29.625Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LocationPin: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M38.4396 38.4388L26.9631 49.9153C26.4612 50.4176 25.8652 50.8162 25.2092 51.0881C24.5531 51.36 23.85 51.5 23.1398 51.5C22.4297 51.5 21.7265 51.36 21.0705 51.0881C20.4145 50.8162 19.8185 50.4176 19.3166 49.9153L7.83737 38.4388C4.81129 35.4125 2.75054 31.5569 1.9157 27.3595C1.08087 23.1621 1.50945 18.8114 3.14725 14.8575C4.78504 10.9037 7.5585 7.52427 11.1169 5.14666C14.6753 2.76904 18.8588 1.5 23.1385 1.5C27.4181 1.5 31.6016 2.76904 35.16 5.14666C38.7184 7.52427 41.4919 10.9037 43.1297 14.8575C44.7675 18.8114 45.1961 23.1621 44.3612 27.3595C43.5264 31.5569 41.4656 35.4125 38.4396 38.4388Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.2528 23.1374C31.2528 25.2894 30.3979 27.3534 28.8761 28.8751C27.3544 30.3969 25.2904 31.2518 23.1383 31.2518C20.9863 31.2518 18.9223 30.3969 17.4006 28.8751C15.8788 27.3534 15.0239 25.2894 15.0239 23.1374C15.0239 20.9853 15.8788 18.9214 17.4006 17.3996C18.9223 15.8779 20.9863 15.0229 23.1383 15.0229C25.2904 15.0229 27.3544 15.8779 28.8761 17.3996C30.3979 18.9214 31.2528 20.9853 31.2528 23.1374Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Globe: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M51.5 26.5C51.5 33.1304 48.8661 39.4893 44.1777 44.1777C39.4893 48.8661 33.1304 51.5 26.5 51.5M51.5 26.5C51.5 19.8696 48.8661 13.5107 44.1777 8.82233C39.4893 4.13392 33.1304 1.5 26.5 1.5M51.5 26.5H1.5M26.5 51.5C19.8696 51.5 13.5107 48.8661 8.82233 44.1777C4.13392 39.4893 1.5 33.1304 1.5 26.5M26.5 51.5C31.1028 51.5 34.8333 40.3056 34.8333 26.5C34.8333 12.6944 31.1028 1.5 26.5 1.5M26.5 51.5C21.8972 51.5 18.1667 40.3056 18.1667 26.5C18.1667 12.6944 21.8972 1.5 26.5 1.5M26.5 1.5C19.8696 1.5 13.5107 4.13392 8.82233 8.82233C4.13392 13.5107 1.5 19.8696 1.5 26.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Click: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
      className={classnames(props)}
    >
      <path
        d="M37.4254 37.4227L31.7954 51.4977L20.5354 20.5327L51.5004 31.7927L37.4254 37.4227ZM37.4254 37.4227L51.5004 51.4977M15.4346 1.50049L17.6219 9.65554M9.65823 17.6192L1.50037 15.4319M34.4696 6.59845L28.4962 12.5719M12.5718 28.4935L6.60396 34.4669"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Image: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={classnames(props)}
    >
      <mask
        id="mask0_1162_878"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <path d="M39 39V0.999996H1V39H39Z" fill="white" stroke="white" strokeWidth="2" />
      </mask>
      <g mask="url(#mask0_1162_878)">
        <path
          d="M12.8125 13.6875C13.5546 13.6875 14.1562 13.0859 14.1562 12.3437C14.1562 11.6016 13.5546 11 12.8125 11C12.0704 11 11.4688 11.6016 11.4688 12.3437C11.4688 13.0859 12.0704 13.6875 12.8125 13.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M38.4375 30.9375C38.4375 33.5263 36.3388 35.625 33.75 35.625H6.25C3.66117 35.625 1.5625 33.5263 1.5625 30.9375V9.0625C1.5625 6.47367 3.66117 4.375 6.25 4.375H33.75C36.3388 4.375 38.4375 6.47367 38.4375 9.0625V23.7109L30.0012 15.2746C28.7808 14.0542 26.8021 14.0542 25.5818 15.2746L16.4048 24.4516"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.59814 29.1406L8.91971 21.819C10.1401 20.5986 12.1187 20.5986 13.3391 21.819L21.0723 29.5522L24.8211 25.8034C26.0415 24.583 28.0202 24.583 29.2406 25.8034L32.8121 29.375"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  PDF: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_1021)">
        <path
          d="M31.3585 16.54H28.2446V24.2228"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.2446 20.3086H31.1111"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6099 16.7202V24.1009"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7699 20.4676C23.7699 22.5369 22.6214 24.1744 20.7992 24.2063C20.1927 24.2169 18.6251 24.2229 18.6251 24.2229C18.6251 24.2229 18.6153 21.5025 18.6153 20.4594C18.6153 19.6026 18.6099 16.7124 18.6099 16.7124C18.6099 16.7124 20.0202 16.7124 20.737 16.7124C22.7356 16.7123 23.7699 18.3982 23.7699 20.4676Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.83154 16.4834V24.2229"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2134 18.6675C14.2134 19.8738 13.1928 20.8516 11.9865 20.8516C11.3883 20.8516 9.84654 20.8612 9.84654 20.8612C9.84654 20.8612 9.83693 19.2755 9.83693 18.6675C9.83693 18.1681 9.83154 16.4834 9.83154 16.4834C9.83154 16.4834 11.2797 16.4834 11.9865 16.4834C13.1928 16.4834 14.2134 17.4613 14.2134 18.6675Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.8257 1.5625V6.40461C29.8257 8.28453 31.3497 9.80852 33.2296 9.80852H38.0717L29.8257 1.5625Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2632 9.60938V6.25C10.2632 3.66117 12.3619 1.5625 14.9507 1.5625H29.8257L38.0716 9.80844"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.0718 22.0693V9.80859H6.18416C3.83369 9.80859 1.92822 11.7141 1.92822 14.0645V25.6258C1.92822 27.9762 3.83369 29.8817 6.18416 29.8817H38.0718V33.7502C38.0718 36.339 35.9731 38.4377 33.3843 38.4377H14.9509C12.3621 38.4377 10.2634 36.339 10.2634 33.7502V30.1548"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_1021">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  PowerPoint: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_993)">
        <mask
          id="mask0_1162_993"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1162_993)">
          <path
            d="M36.5983 6.25381C37.3054 6.98819 37.7405 7.98741 37.7405 9.08662V26.7413C37.7405 28.9968 35.9124 30.8257 33.6569 30.8257H6.34287C4.0874 30.8257 2.25928 28.9968 2.25928 26.7413V9.08662C2.25928 7.98741 2.69443 6.98819 3.40146 6.25381"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.84687 6.25391H37.4125C38.518 6.25391 39.4141 5.35781 39.4141 4.25234V2.5875C39.4141 1.48203 38.518 0.585937 37.4125 0.585937H2.5875C1.48203 0.585937 0.585938 1.48203 0.585938 2.5875V4.25234C0.585938 5.35781 1.48203 6.25391 2.5875 6.25391H7.50312"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.8117 37.8508C23.1265 37.3438 23.3085 36.7461 23.3085 36.1055C23.3085 34.2781 21.8273 32.7969 20 32.7969C18.1727 32.7969 16.6914 34.2781 16.6914 36.1055C16.6914 37.9328 18.1727 39.4141 20 39.4141C20.3734 39.4141 20.7328 39.3523 21.068 39.2383M20 37.1883C19.4023 37.1883 18.9171 36.7039 18.9171 36.1055C18.9171 35.5078 19.4023 35.0227 20 35.0227C20.5977 35.0227 21.0828 35.5078 21.0828 36.1055C21.0828 36.7039 20.5977 37.1883 20 37.1883Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 32.7969V30.8253"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.2827 13.7617H31.201"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.7319 14.0462V22.6675"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.3613 16.275V22.6675"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4035 16.275C15.4035 17.663 14.2291 18.7882 12.8411 18.7882C12.1527 18.7882 10.3787 18.7993 10.3787 18.7993C10.3787 18.7993 10.3675 16.9746 10.3675 16.275C10.3675 15.7004 10.3613 13.7618 10.3613 13.7618H12.8411C14.2291 13.7618 15.4035 14.887 15.4035 16.275Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.6597 16.275V22.6675"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.7018 16.275C23.7018 17.663 22.5274 18.7882 21.1394 18.7882C20.4511 18.7882 18.6769 18.7993 18.6769 18.7993C18.6769 18.7993 18.6658 16.9746 18.6658 16.275C18.6658 15.7004 18.6597 13.7618 18.6597 13.7618H21.1394C22.5274 13.7618 23.7018 14.887 23.7018 16.275Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1162_993">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  GoogleSlideshow: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_364)">
        <path
          d="M39.2188 0H0.78125C0.349766 0 0 0.349766 0 0.78125V5.78125C0 6.21273 0.349766 6.5625 0.78125 6.5625H1.5625V29.8487C1.5625 31.141 2.61391 32.1924 3.90625 32.1924H19.2287V34.1648C17.9645 34.5052 17.0312 35.6611 17.0312 37.0312C17.0312 38.6682 18.363 40 20 40C21.637 40 22.9688 38.6682 22.9688 37.0312C22.9688 35.6683 22.0452 34.5177 20.7912 34.1704V32.1924H23.9204C24.3519 32.1924 24.7016 31.8427 24.7016 31.4112C24.7016 30.9797 24.3519 30.6299 23.9204 30.6299H3.90625C3.47547 30.6299 3.125 30.2795 3.125 29.8487V6.5625H36.875V29.8487C36.875 30.2795 36.5245 30.6299 36.0938 30.6299H31.3028C30.8713 30.6299 30.5216 30.9797 30.5216 31.4112C30.5216 31.8427 30.8713 32.1924 31.3028 32.1924H36.0938C37.3861 32.1924 38.4375 31.141 38.4375 29.8487V6.5625H39.2188C39.6502 6.5625 40 6.21273 40 5.78125V0.78125C40 0.349766 39.6502 0 39.2188 0ZM21.4062 37.0312C21.4062 37.8066 20.7754 38.4375 20 38.4375C19.2246 38.4375 18.5938 37.8066 18.5938 37.0312C18.5938 36.2559 19.2246 35.625 20 35.625C20.7754 35.625 21.4062 36.2559 21.4062 37.0312ZM38.4375 5H1.5625V1.5625H38.4375V5Z"
          fill="currentColor"
        />
        <path
          d="M27.9156 30.8588C27.7711 30.7135 27.5695 30.6299 27.3633 30.6299C27.1578 30.6299 26.9562 30.7135 26.8109 30.8588C26.6656 31.0041 26.582 31.2057 26.582 31.4111C26.582 31.6174 26.6656 31.8182 26.8109 31.9635C26.957 32.1096 27.1578 32.1924 27.3633 32.1924C27.5695 32.1924 27.7703 32.1096 27.9156 31.9635C28.0617 31.8182 28.1453 31.6166 28.1453 31.4111C28.1453 31.2057 28.0617 31.0041 27.9156 30.8588Z"
          fill="currentColor"
        />
        <path
          d="M32.5004 22.1875H22.2275C21.7961 22.1875 21.4463 22.5373 21.4463 22.9688C21.4463 23.4002 21.7961 23.75 22.2275 23.75H32.5004C32.9318 23.75 33.2816 23.4002 33.2816 22.9688C33.2816 22.5373 32.9318 22.1875 32.5004 22.1875Z"
          fill="currentColor"
        />
        <path
          d="M32.5004 14.0625H22.2275C21.7961 14.0625 21.4463 14.4123 21.4463 14.8438C21.4463 15.2752 21.7961 15.625 22.2275 15.625H32.5004C32.9318 15.625 33.2816 15.2752 33.2816 14.8438C33.2816 14.4123 32.9318 14.0625 32.5004 14.0625Z"
          fill="currentColor"
        />
        <path
          d="M32.5 10H25.2344C24.8029 10 24.4531 10.3498 24.4531 10.7812C24.4531 11.2127 24.8029 11.5625 25.2344 11.5625H32.5C32.9315 11.5625 33.2812 11.2127 33.2812 10.7812C33.2812 10.3498 32.9315 10 32.5 10Z"
          fill="currentColor"
        />
        <path
          d="M22.7799 10.2289C22.6346 10.0836 22.433 10 22.2275 10C22.0221 10 21.8205 10.0836 21.6752 10.2289C21.5299 10.3742 21.4463 10.5758 21.4463 10.7812C21.4463 10.9867 21.5299 11.1883 21.6752 11.3336C21.8205 11.4789 22.0221 11.5625 22.2275 11.5625C22.433 11.5625 22.6346 11.4789 22.7799 11.3336C22.9252 11.1883 23.0088 10.9867 23.0088 10.7812C23.0088 10.5758 22.9252 10.3742 22.7799 10.2289Z"
          fill="currentColor"
        />
        <path
          d="M32.5004 18.125H22.2275C21.7961 18.125 21.4463 18.4748 21.4463 18.9062C21.4463 19.3377 21.7961 19.6875 22.2275 19.6875H32.5004C32.9318 19.6875 33.2816 19.3377 33.2816 18.9062C33.2816 18.4748 32.9318 18.125 32.5004 18.125Z"
          fill="currentColor"
        />
        <path
          d="M32.5004 26.25H22.2275C21.7961 26.25 21.4463 26.5998 21.4463 27.0312C21.4463 27.4627 21.7961 27.8125 22.2275 27.8125H32.5004C32.9318 27.8125 33.2816 27.4627 33.2816 27.0312C33.2816 26.5998 32.9318 26.25 32.5004 26.25Z"
          fill="currentColor"
        />
        <path
          d="M17.7437 22.1875H7.5C7.06852 22.1875 6.71875 22.5373 6.71875 22.9688C6.71875 23.4002 7.06852 23.75 7.5 23.75H17.7437C18.1752 23.75 18.5249 23.4002 18.5249 22.9688C18.5249 22.5373 18.1752 22.1875 17.7437 22.1875Z"
          fill="currentColor"
        />
        <path
          d="M17.7437 26.25H7.5C7.06852 26.25 6.71875 26.5998 6.71875 27.0312C6.71875 27.4627 7.06852 27.8125 7.5 27.8125H17.7437C18.1752 27.8125 18.5249 27.4627 18.5249 27.0312C18.5249 26.5998 18.1752 26.25 17.7437 26.25Z"
          fill="currentColor"
        />
        <path
          d="M17.7728 10H7.5C7.06852 10 6.71875 10.3498 6.71875 10.7812V18.9062C6.71875 19.3377 7.06852 19.6875 7.5 19.6875H17.7728C18.2043 19.6875 18.5541 19.3377 18.5541 18.9062V10.7812C18.5541 10.3498 18.2043 10 17.7728 10ZM16.9916 18.125H8.28125V11.5625H16.9916V18.125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_364">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Canvas: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_439)">
        <path
          d="M18.2419 13.7547C20.908 13.7547 23.077 11.5857 23.077 8.9196C23.077 6.25351 20.908 4.08447 18.2419 4.08447C15.5758 4.08447 13.4067 6.25351 13.4067 8.9196C13.4067 11.5857 15.5758 13.7547 18.2419 13.7547ZM18.2419 5.69618C20.0193 5.69618 21.4653 7.14221 21.4653 8.9196C21.4653 10.697 20.0193 12.143 18.2419 12.143C16.4645 12.143 15.0184 10.697 15.0184 8.9196C15.0184 7.14221 16.4645 5.69618 18.2419 5.69618Z"
          fill="currentColor"
        />
        <path
          d="M9.37742 11.3374C7.15568 11.3374 5.34814 13.1449 5.34814 15.3667C5.34814 17.5884 7.15568 19.396 9.37742 19.396C11.5992 19.396 13.4067 17.5884 13.4067 15.3667C13.4067 13.1449 11.5992 11.3374 9.37742 11.3374ZM9.37742 17.7842C8.04438 17.7842 6.95986 16.6997 6.95986 15.3667C6.95986 14.0336 8.04438 12.9491 9.37742 12.9491C10.7105 12.9491 11.795 14.0336 11.795 15.3667C11.795 16.6997 10.7105 17.7842 9.37742 17.7842Z"
          fill="currentColor"
        />
        <path
          d="M6.95975 21.0073C5.18235 21.0073 3.73633 22.4534 3.73633 24.2307C3.73633 26.0081 5.18235 27.4542 6.95975 27.4542C8.73714 27.4542 10.1832 26.0081 10.1832 24.2307C10.1832 22.4534 8.73722 21.0073 6.95975 21.0073ZM6.95975 25.8425C6.07105 25.8425 5.34804 25.1194 5.34804 24.2307C5.34804 23.342 6.07105 22.619 6.95975 22.619C7.84845 22.619 8.57146 23.342 8.57146 24.2307C8.57146 25.1194 7.84845 25.8425 6.95975 25.8425Z"
          fill="currentColor"
        />
        <path
          d="M39.7299 0.258998C39.4707 0.0283621 39.0932 -0.0103995 38.7925 0.162456C36.3608 1.56094 34.1342 3.26153 32.1518 5.23137C28.7923 2.53312 24.61 1.17695 19.3938 1.09153C19.3675 1.09112 19.3415 1.09193 19.3154 1.09403C19.1709 1.10579 18.994 1.11457 18.7891 1.12481C18.2375 1.15245 17.5509 1.18678 16.854 1.30798C12.7594 2.01995 9.33259 3.52892 6.66844 5.79305C3.90459 8.14196 1.94612 11.3162 0.847743 15.2274C-0.26885 19.2036 -0.282469 22.9707 0.807209 26.4241C1.88665 29.8448 4.04715 32.9384 7.22883 35.6476C10.5574 38.4821 14.5607 39.945 19.1279 39.945H19.162C20.8612 39.945 22.144 39.2444 22.873 37.8898C23.6175 36.5056 23.4745 35.0809 22.4488 33.6424L22.4358 33.6278C22.3207 33.4657 22.2121 33.3145 22.1239 33.1637C21.7134 32.4615 21.6847 31.7986 22.034 31.0754C22.4878 30.1354 23.1309 29.6762 24.0584 29.6294C24.9427 29.5845 25.8496 29.5669 26.7267 29.5497C27.3481 29.5376 27.9906 29.5251 28.6253 29.5029C31.3245 29.4086 33.714 28.4823 35.5354 26.8239C37.3645 25.1585 38.4922 22.8711 38.7966 20.2092C39.2694 16.071 38.1425 12.1834 35.4487 8.64368C37.2747 6.3706 38.7813 3.86673 39.9348 1.1788C40.0715 0.860085 39.9891 0.489553 39.7299 0.258998ZM37.1953 20.0262C36.6679 24.6401 33.2818 27.7277 28.5692 27.8923C27.9467 27.914 27.3105 27.9264 26.6951 27.9385C25.8057 27.956 24.8861 27.974 23.977 28.0202C22.4634 28.0965 21.2896 28.911 20.5827 30.3756C20.0035 31.5749 20.0555 32.821 20.7325 33.9786C20.8565 34.1911 20.9914 34.381 21.1219 34.5647L21.1356 34.5841C21.8031 35.5202 21.9012 36.2942 21.4537 37.1262C21.0053 37.9592 20.2774 38.3333 19.1642 38.3333C19.1552 38.3333 19.1461 38.3333 19.1372 38.3333C14.9603 38.3333 11.3053 37.0021 8.27378 34.4206C2.30521 29.3383 0.328773 23.0298 2.3995 15.6561C4.39907 8.53618 9.35524 4.24427 17.1302 2.89237C17.7299 2.78809 18.362 2.75828 18.8697 2.73289C19.0624 2.72322 19.2453 2.715 19.4054 2.70292C24.1727 2.78697 27.9866 3.99889 31.0339 6.40091C30.9512 6.49172 30.8679 6.58206 30.7862 6.67393L22.3895 16.1114C21.3935 15.2251 19.8623 15.3146 18.9763 16.3106C18.2898 17.0822 18.1893 18.175 18.6418 19.0403C17.055 19.7039 15.8656 20.7413 15.0976 22.1357C13.3219 25.3599 14.4901 29.2985 14.5407 29.4645C14.6327 29.7666 14.8928 29.9871 15.2057 30.0285C15.2412 30.0333 15.2766 30.0355 15.3117 30.0355C15.5868 30.0355 15.8462 29.8944 15.9948 29.6571C16.0066 29.6381 17.2109 27.7518 19.5155 27.4341C21.4721 27.1651 23.1064 25.8171 23.6788 24.0001C23.7333 23.8274 23.7779 23.6536 23.8144 23.4791C24.0016 23.5251 24.1949 23.5492 24.3915 23.5492C24.4393 23.5492 24.4873 23.5477 24.5355 23.5449C25.1801 23.5073 25.7716 23.2209 26.2008 22.7385C27.087 21.7426 26.9976 20.2114 26.0017 19.3253L34.3808 9.90775C36.6591 13.0291 37.6063 16.4285 37.1953 20.0262ZM24.3284 19.9939C24.3284 19.994 24.3285 19.9941 24.3286 19.9942L24.9303 20.5296C25.2623 20.8249 25.2921 21.3353 24.9967 21.6673C24.8537 21.8281 24.6564 21.9236 24.4416 21.9361C24.2263 21.949 24.0198 21.8767 23.859 21.7337L20.2467 18.5197C19.9148 18.2243 19.8849 17.7139 20.1803 17.382C20.3394 17.2032 20.5606 17.1121 20.7828 17.1121C20.9734 17.1121 21.1648 17.1792 21.3181 17.3155L23.8564 19.5739L24.3284 19.9939ZM19.8394 20.3146L22.3119 22.5144C22.303 22.8485 22.2463 23.1839 22.1416 23.5155C21.7553 24.7415 20.6383 25.6529 19.2956 25.8374C17.7438 26.0514 16.5779 26.7911 15.7992 27.4785C15.659 26.2324 15.6701 24.4308 16.5137 22.9053C17.1857 21.6901 18.3042 20.8206 19.8394 20.3146ZM33.1945 8.8167L24.7976 18.2541L24.1955 17.7184L23.5935 17.1828L31.9903 7.74539C33.5572 5.98428 35.3129 4.41786 37.2311 3.0674C36.113 5.12959 34.7614 7.05558 33.1945 8.8167Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_439">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  DateAndTime: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_325)">
        <path
          d="M8.81979 16.1428C8.81979 15.027 7.91197 14.1191 6.79611 14.1191H5.55353C4.43768 14.1191 3.52979 15.027 3.52979 16.1428V17.3853C3.52979 18.5012 4.43768 19.4091 5.55353 19.4091H6.79604C7.91189 19.4091 8.81971 18.5012 8.81971 17.3853L8.81979 16.1428ZM7.64791 17.3853C7.64791 17.8551 7.26572 18.2372 6.79611 18.2372H5.55353C5.08377 18.2372 4.70166 17.855 4.70166 17.3853V16.1428C4.70166 15.6731 5.08385 15.291 5.55353 15.291H6.79604C7.26572 15.291 7.64783 15.6732 7.64783 16.1428L7.64791 17.3853Z"
          fill="currentColor"
        />
        <path
          d="M13.2014 19.4091H14.4439C15.5598 19.4091 16.4677 18.5012 16.4677 17.3853V16.1428C16.4677 15.027 15.5598 14.1191 14.4439 14.1191H13.2014C12.0855 14.1191 11.1777 15.027 11.1777 16.1428V17.3853C11.1777 18.5012 12.0855 19.4091 13.2014 19.4091ZM12.3495 16.1428C12.3495 15.6731 12.7317 15.291 13.2013 15.291H14.4438C14.9136 15.291 15.2957 15.6732 15.2957 16.1428V17.3853C15.2957 17.8551 14.9135 18.2372 14.4438 18.2372H13.2014C12.7317 18.2372 12.3496 17.855 12.3496 17.3853L12.3495 16.1428Z"
          fill="currentColor"
        />
        <path
          d="M20.8494 19.4091H22.0919C23.2077 19.4091 24.1156 18.5012 24.1156 17.3853V16.1428C24.1156 15.027 23.2077 14.1191 22.0919 14.1191H20.8494C19.7336 14.1191 18.8257 15.027 18.8257 16.1428V17.3853C18.8257 18.5012 19.7336 19.4091 20.8494 19.4091ZM19.9976 16.1428C19.9976 15.6731 20.3797 15.291 20.8494 15.291H22.0919C22.5616 15.291 22.9437 15.6732 22.9437 16.1428V17.3853C22.9437 17.8551 22.5615 18.2372 22.0919 18.2372H20.8494C20.3797 18.2372 19.9976 17.855 19.9976 17.3853V16.1428Z"
          fill="currentColor"
        />
        <path
          d="M29.7399 19.4091C30.8557 19.4091 31.7636 18.5012 31.7636 17.3853V16.1428C31.7636 15.027 30.8557 14.1191 29.7399 14.1191H28.4974C27.3815 14.1191 26.4736 15.027 26.4736 16.1428V17.3853C26.4736 18.5012 27.3815 19.4091 28.4974 19.4091H29.7399ZM27.6454 17.3853V16.1428C27.6454 15.6731 28.0276 15.291 28.4973 15.291H29.7398C30.2096 15.291 30.5917 15.6732 30.5917 16.1428V17.3853C30.5917 17.8551 30.2095 18.2372 29.7398 18.2372H28.4973C28.0276 18.2372 27.6454 17.8551 27.6454 17.3853Z"
          fill="currentColor"
        />
        <path
          d="M6.79604 29.4155H5.55353C4.43768 29.4155 3.52979 30.3233 3.52979 31.4392V32.6817C3.52979 33.7976 4.43768 34.7054 5.55353 34.7054H6.79604C7.91189 34.7054 8.81971 33.7976 8.81971 32.6817V31.4392C8.81979 30.3233 7.91189 29.4155 6.79604 29.4155ZM7.64791 32.6817C7.64791 33.1515 7.26572 33.5336 6.79611 33.5336H5.55353C5.08377 33.5336 4.70166 33.1514 4.70166 32.6817V31.4392C4.70166 30.9695 5.08385 30.5874 5.55353 30.5874H6.79604C7.26572 30.5874 7.64783 30.9696 7.64783 31.4392L7.64791 32.6817Z"
          fill="currentColor"
        />
        <path
          d="M11.1777 32.6817C11.1777 33.7976 12.0855 34.7054 13.2014 34.7054H14.4439C15.5598 34.7054 16.4677 33.7976 16.4677 32.6817V31.4392C16.4677 30.3233 15.5598 29.4155 14.4439 29.4155H13.2015C12.0856 29.4155 11.1778 30.3233 11.1778 31.4392L11.1777 32.6817ZM12.3496 31.4392C12.3496 30.9695 12.7318 30.5874 13.2014 30.5874H14.4439C14.9137 30.5874 15.2958 30.9696 15.2958 31.4392V32.6817C15.2958 33.1515 14.9136 33.5336 14.4439 33.5336H13.2015C12.7318 33.5336 12.3497 33.1514 12.3497 32.6817L12.3496 31.4392Z"
          fill="currentColor"
        />
        <path
          d="M8.81979 23.7908C8.81979 22.675 7.91197 21.7671 6.79611 21.7671H5.55353C4.43768 21.7671 3.52979 22.675 3.52979 23.7908V25.0333C3.52979 26.1492 4.43768 27.057 5.55353 27.057H6.79604C7.91189 27.057 8.81971 26.1492 8.81971 25.0333L8.81979 23.7908ZM7.64791 25.0334C7.64791 25.5031 7.26572 25.8852 6.79611 25.8852H5.55353C5.08377 25.8852 4.70166 25.503 4.70166 25.0334V23.7909C4.70166 23.3212 5.08385 22.939 5.55353 22.939H6.79604C7.26572 22.939 7.64783 23.3212 7.64783 23.7909L7.64791 25.0334Z"
          fill="currentColor"
        />
        <path
          d="M11.1777 25.0338C11.1777 26.1497 12.0855 27.0575 13.2014 27.0575H14.4439C15.5598 27.0575 16.4677 26.1497 16.4677 25.0338V23.7913C16.4677 22.6755 15.5598 21.7676 14.4439 21.7676H13.2015C12.0856 21.7676 11.1778 22.6755 11.1778 23.7913L11.1777 25.0338ZM12.3496 23.7912C12.3496 23.3215 12.7318 22.9394 13.2014 22.9394H14.4439C14.9137 22.9394 15.2958 23.3216 15.2958 23.7912V25.0337C15.2958 25.5034 14.9136 25.8855 14.4439 25.8855H13.2015C12.7318 25.8855 12.3497 25.5034 12.3497 25.0337L12.3496 23.7912Z"
          fill="currentColor"
        />
        <path
          d="M35.2936 22.4416C35.2938 10.1095 35.2938 11.7654 35.2936 9.97922C35.2936 7.2632 33.2292 5.02078 30.5872 4.73734V4.11586C30.5872 1.84633 28.7408 0 26.4713 0C24.2019 0 22.3555 1.84633 22.3555 4.11578V4.70648H12.938V4.11578C12.938 1.84633 11.0916 0 8.82219 0C6.55273 0 4.70641 1.84633 4.70641 4.11578V4.73711C2.06445 5.02055 0 7.26297 0 9.97891V32.9625C0 35.8698 2.36531 38.2352 5.27266 38.2352H8.63125C8.95492 38.2352 9.21719 37.9729 9.21719 37.6492C9.21719 37.3255 8.95492 37.0633 8.63125 37.0633H5.27266C3.01148 37.0633 1.17188 35.2237 1.17188 32.9625V11.7617H27.3984C27.7221 11.7617 27.9844 11.4995 27.9844 11.1758C27.9844 10.8521 27.7221 10.5898 27.3984 10.5898H1.17188V9.97898C1.17188 7.71781 3.01148 5.8782 5.27266 5.8782C5.26484 5.8782 5.29992 5.87836 9.41281 5.87836V7.05734C9.41281 8.02914 10.2035 8.81992 11.1755 8.81992C12.1473 8.81992 12.938 8.02922 12.938 7.05734V5.87828H27.062V7.05727C27.062 8.02906 27.8527 8.81984 28.8246 8.81984C29.7965 8.81984 30.5872 8.02914 30.5872 7.05727V5.91836C32.5812 6.19516 34.1217 7.91023 34.1217 9.97922V10.5898H30.1328C29.8091 10.5898 29.5469 10.8521 29.5469 11.1758C29.5469 11.4995 29.8091 11.7617 30.1328 11.7617H34.1217V21.8676C30.76 20.5012 26.8222 21.186 24.1148 23.7555C24.0957 22.656 23.1959 21.7673 22.092 21.7673H20.8495C19.7337 21.7673 18.8258 22.6752 18.8258 23.7911V25.0336C18.8258 26.1495 19.7337 27.0573 20.8495 27.0573H21.8648C21.5573 27.8132 21.3525 28.6024 21.2524 29.4153H20.8495C19.7337 29.4153 18.8258 30.3231 18.8258 31.439V32.6815C18.8258 33.7973 19.7337 34.7052 20.8495 34.7052H22.128C22.5525 35.5744 23.1069 36.3689 23.7659 37.0633H11.3656C11.042 37.0633 10.7797 37.3255 10.7797 37.6492C10.7797 37.9729 11.042 38.2352 11.3656 38.2352H25.1094C26.6538 39.3453 28.5466 40 30.5895 40C35.7785 40 40 35.7785 40 30.5895C40 27.113 38.1048 24.0709 35.2936 22.4416ZM8.23148 4.70641V4.1157C8.23148 3.79 8.49648 3.52508 8.82219 3.52508C9.14789 3.52508 9.41289 3.79008 9.41289 4.1157V4.70641H8.23148ZM11.7661 7.05727C11.7661 7.38297 11.5011 7.64797 11.1754 7.64797C10.8496 7.64797 10.5847 7.38297 10.5847 7.05727V4.11578C10.5847 3.14398 9.79398 2.35328 8.82211 2.35328C7.85031 2.35328 7.05953 3.14398 7.05953 4.11578V4.70648H5.87828V4.11578C5.87828 2.4925 7.19891 1.17188 8.82219 1.17188C10.4455 1.17188 11.7662 2.4925 11.7662 4.11578L11.7661 7.05727ZM25.8806 4.70641V4.1157C25.8806 3.79 26.1456 3.52508 26.4713 3.52508C26.797 3.52508 27.062 3.79008 27.062 4.1157V4.70641H25.8806ZM29.4153 7.05727C29.4153 7.38297 29.1503 7.64797 28.8246 7.64797C28.4989 7.64797 28.2339 7.38297 28.2339 7.05727V4.11578C28.2339 3.14398 27.4432 2.35328 26.4713 2.35328C25.4995 2.35328 24.7087 3.14398 24.7087 4.11578V4.70648H23.5274V4.11578C23.5274 2.49258 24.848 1.17188 26.4713 1.17188C28.0946 1.17188 29.4153 2.4925 29.4153 4.11578V7.05727ZM19.9977 25.0336V23.7911C19.9977 23.3213 20.3798 22.9392 20.8495 22.9392H22.092C22.5617 22.9392 22.9438 23.3214 22.9438 23.7911V25.0988C22.7634 25.3509 22.5948 25.6134 22.4383 25.8854H20.8495C20.3798 25.8854 19.9977 25.5032 19.9977 25.0336ZM20.8495 33.5334C20.3798 33.5334 19.9977 33.1512 19.9977 32.6816V31.4391C19.9977 30.9694 20.3798 30.5873 20.8495 30.5873H21.179C21.179 31.5686 21.3297 32.5601 21.6511 33.5335H20.8495V33.5334ZM30.5895 38.8281C26.0467 38.8281 22.3509 35.1323 22.3509 30.5895C22.3509 26.0884 25.9853 22.3509 30.5895 22.3509C35.1323 22.3509 38.8281 26.0467 38.8281 30.5895C38.8281 35.1323 35.1323 38.8281 30.5895 38.8281Z"
          fill="currentColor"
        />
        <path
          d="M30.5897 24.1206C27.0226 24.1206 24.1206 27.0226 24.1206 30.5897C24.1206 34.1566 27.0226 37.0587 30.5897 37.0587C34.1566 37.0587 37.0587 34.1566 37.0587 30.5897C37.0587 27.0226 34.1566 24.1206 30.5897 24.1206ZM30.5897 35.8868C27.6688 35.8868 25.2925 33.5105 25.2925 30.5897C25.2925 27.6688 27.6688 25.2925 30.5897 25.2925C33.5105 25.2925 35.8868 27.6688 35.8868 30.5897C35.8868 33.5105 33.5105 35.8868 30.5897 35.8868Z"
          fill="currentColor"
        />
        <path
          d="M33.2047 31.242L31.1753 30.2273V27.0596C31.1753 26.7359 30.913 26.4736 30.5894 26.4736C30.2657 26.4736 30.0034 26.7359 30.0034 27.0596V30.5895C30.0034 30.8114 30.1288 31.0143 30.3273 31.1136L32.6805 32.2902C32.9702 32.4352 33.3222 32.3173 33.4666 32.0282C33.6114 31.7387 33.494 31.3868 33.2047 31.242Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_325">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Weather: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_340)">
        <path
          d="M34.0997 13.441C33.7817 13.441 33.4656 13.4665 33.1538 13.5171C32.7729 11.6765 31.8165 9.99728 30.4062 8.71915C28.7631 7.23007 26.636 6.41005 24.4169 6.41005C22.1164 6.41005 20.0023 7.2839 18.4098 8.73197C17.0439 7.01715 14.9452 5.98438 12.7251 5.98438C8.72397 5.98438 5.4689 9.23945 5.4689 13.2405C5.4689 14.8801 6.01904 16.4402 6.99775 17.697C4.15874 18.0577 1.95605 20.4866 1.95605 23.4219C1.95605 26.605 4.54574 29.1947 7.72885 29.1947H24.5859C26.8689 29.1947 28.7539 27.4611 28.9953 25.2414H34.0997C37.3533 25.2414 40.0003 22.5947 40.0003 19.3416C40.0002 16.088 37.3533 13.441 34.0997 13.441ZM12.725 7.54706C14.5499 7.54706 16.2709 8.43631 17.3355 9.89883C16.4841 11.0067 15.9012 12.3134 15.6461 13.6872C13.1649 14.0689 10.9744 15.8308 9.92544 18.0823C9.78339 18.0239 9.62884 17.9676 9.48086 17.9206C7.94489 16.8542 7.03143 15.113 7.03143 13.2405C7.0315 10.1011 9.58564 7.54706 12.725 7.54706ZM34.0997 23.6787H28.8894C28.5258 22.2237 27.4109 21.0213 25.987 20.55C25.5863 20.4174 25.1662 20.3402 24.7442 20.3254C24.5565 18.9305 23.9806 17.6001 23.1008 16.5022C22.8649 16.2075 22.4587 16.129 22.1352 16.295C22.0882 16.319 22.044 16.3487 22.0023 16.3811C21.6656 16.651 21.6114 17.1427 21.8812 17.4794C22.7208 18.5269 23.2041 19.8304 23.2487 21.172C23.2581 21.454 23.4245 21.7151 23.676 21.8427C23.9663 21.9902 24.2778 21.8856 24.5859 21.8856C26.1454 21.8856 27.4593 23.2017 27.4593 24.7586C27.4593 26.3431 26.1703 27.632 24.5859 27.632H7.72877C5.40733 27.632 3.51866 25.7434 3.51866 23.4219C3.51866 21.1005 5.40733 19.2118 7.72877 19.2118C8.49598 19.2118 9.26146 19.4246 9.91646 19.8247C10.3377 20.0816 10.9136 19.9009 11.0764 19.4111C11.8517 17.0795 13.9836 15.384 16.4329 15.1616C16.8627 15.1225 17.1025 14.7426 17.1404 14.3128C17.2754 12.7815 18.1735 11.2536 18.9898 10.3604C20.3723 8.84776 22.3685 7.97282 24.4169 7.97282C26.2474 7.97282 28.0017 8.64915 29.3568 9.87718C30.7027 11.0969 31.5475 12.7585 31.7358 14.5559C31.7603 14.7907 31.8897 15.0017 32.0876 15.1301C32.2856 15.2585 32.5309 15.2906 32.7554 15.2174C33.1894 15.0756 33.6418 15.0038 34.0998 15.0038C36.4917 15.0038 38.4377 16.9497 38.4377 19.3417C38.4375 21.733 36.4916 23.6787 34.0997 23.6787Z"
          fill="currentColor"
        />
        <path
          d="M12.2774 4.30413C12.709 4.30413 13.0588 3.95432 13.0588 3.52278V0.934663C13.0588 0.503128 12.709 0.15332 12.2774 0.15332C11.8459 0.15332 11.4961 0.503128 11.4961 0.934663V3.52286C11.4961 3.95432 11.8459 4.30413 12.2774 4.30413Z"
          fill="currentColor"
        />
        <path
          d="M4.15081 13.1153C4.15081 12.6838 3.801 12.334 3.36946 12.334H0.781343C0.349807 12.334 0 12.6838 0 13.1153C0 13.5469 0.349807 13.8967 0.781343 13.8967H3.36946C3.801 13.8967 4.15081 13.5469 4.15081 13.1153Z"
          fill="currentColor"
        />
        <path
          d="M5.32358 7.14141C5.47617 7.29401 5.67612 7.37027 5.87606 7.37027C6.07601 7.37027 6.27603 7.29393 6.42855 7.14141C6.73367 6.8363 6.73374 6.34155 6.42855 6.03644L4.59849 4.20637C4.2933 3.90118 3.79863 3.90134 3.49351 4.20637C3.1884 4.51149 3.18832 5.00624 3.49351 5.31135L5.32358 7.14141Z"
          fill="currentColor"
        />
        <path
          d="M33.9326 29.7256H31.9888C31.5574 29.7256 31.2075 30.0754 31.2075 30.5069C31.2075 30.9385 31.5574 31.2883 31.9888 31.2883H33.9326C34.9176 31.2883 35.7191 32.0897 35.7191 33.0748C35.7191 34.0599 34.9176 34.8613 33.9326 34.8613H12.2774C11.8459 34.8613 11.4961 35.2111 11.4961 35.6426C11.4961 36.0742 11.8459 36.424 12.2774 36.424H33.9326C35.7794 36.424 37.2817 34.9215 37.2817 33.0747C37.2817 31.228 35.7794 29.7256 33.9326 29.7256Z"
          fill="currentColor"
        />
        <path
          d="M28.0249 38.2842H19.4601C19.0285 38.2842 18.6787 38.634 18.6787 39.0655C18.6787 39.4971 19.0285 39.8469 19.4601 39.8469H28.0248C28.4563 39.8469 28.8062 39.4971 28.8062 39.0655C28.8062 38.634 28.4564 38.2842 28.0249 38.2842Z"
          fill="currentColor"
        />
        <path
          d="M32.3799 38.7676C32.2183 38.3731 31.752 38.183 31.3595 38.3449C30.9658 38.5073 30.7744 38.9713 30.9368 39.3645C31.0991 39.7578 31.5641 39.9509 31.9573 39.7873C32.3494 39.624 32.5438 39.1608 32.3799 38.7676Z"
          fill="currentColor"
        />
        <path
          d="M17.112 32.006C17.112 31.5744 16.7622 31.2246 16.3306 31.2246H6.87607C6.44453 31.2246 6.09473 31.5744 6.09473 32.006C6.09473 32.4375 6.44453 32.7873 6.87607 32.7873H16.3306C16.7622 32.7873 17.112 32.4375 17.112 32.006Z"
          fill="currentColor"
        />
        <path
          d="M20.4298 14.5803C20.2684 14.1867 19.8016 13.9949 19.4093 14.1576C19.0161 14.3209 18.824 14.7837 18.9866 15.1773C19.1489 15.5702 19.6143 15.7639 20.0071 15.6C20.399 15.4364 20.5938 14.974 20.4298 14.5803Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_340">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  RSS: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      fill="none"
      className={classnames(props)}
    >
      <g clipPath="url(#clip0_1162_352)">
        <path
          d="M5.41929 27.1611C2.4311 27.1611 0 29.5922 0 32.5805C0 35.5688 2.4311 37.9998 5.41929 37.9998C8.40756 37.9998 10.8387 35.5687 10.8387 32.5805C10.8387 29.5922 8.40756 27.1611 5.41929 27.1611ZM5.41929 35.7616C3.66521 35.7616 2.23821 34.3346 2.23821 32.5805C2.23821 30.8264 3.66521 29.3993 5.41929 29.3993C7.17338 29.3993 8.60045 30.8264 8.60045 32.5805C8.60053 34.3346 7.17338 35.7616 5.41929 35.7616Z"
          fill="#C147E9"
        />
        <path
          d="M17.8131 20.1863C13.3539 15.7272 7.4252 13.2715 1.11907 13.2715C0.50105 13.2715 0 13.7725 0 14.3906V20.4264C0 21.0444 0.50105 21.5454 1.11907 21.5454C9.57479 21.5454 16.454 28.4247 16.454 36.8804C16.454 37.4984 16.955 37.9994 17.5731 37.9994H23.6089C24.2269 37.9994 24.728 37.4984 24.728 36.8804C24.728 30.5742 22.2722 24.6455 17.8131 20.1863ZM18.6569 35.7612C18.1009 26.9615 11.038 19.8985 2.23821 19.3425V15.5383C7.52606 15.8092 12.4588 17.9975 16.2304 21.769C20.002 25.5406 22.1902 30.4734 22.4611 35.7612H18.6569Z"
          fill="#C147E9"
        />
        <path
          d="M35.0998 22.5237C33.2421 18.1315 30.5834 14.1877 27.1977 10.8021C23.812 7.41629 19.8684 4.75771 15.476 2.89987C10.9265 0.975678 6.09609 0 1.11914 0C0.501124 0 0 0.50105 0 1.11914V7.1549C0 7.77291 0.50105 8.27404 1.11914 8.27404C16.8929 8.27404 29.7258 21.107 29.7258 36.8807C29.7258 37.4987 30.2269 37.9998 30.845 37.9998H36.8807C37.4987 37.9998 37.9999 37.4987 37.9999 36.8807C37.9998 31.9036 37.0241 27.0733 35.0998 22.5237ZM31.944 35.7614C31.366 19.6416 18.358 6.63366 2.23821 6.05572V2.25573C6.51899 2.39036 10.6735 3.29887 14.6041 4.96137C18.7296 6.70632 22.4342 9.20392 25.615 12.3848C28.7959 15.5655 31.2935 19.2701 33.0384 23.3956C34.7009 27.3262 35.6093 31.4806 35.744 35.7615H31.944V35.7614Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_352">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Ticker: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1162_431)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 14.286C20 13.497 20.6396 12.8574 21.4286 12.8574H37.1429C37.9006 12.8574 38.6274 13.1585 39.1631 13.6943C39.6989 14.2301 40 14.9568 40 15.7146V24.286C40 25.0437 39.6989 25.7705 39.1631 26.3063C38.6274 26.8421 37.9006 27.1431 37.1429 27.1431H21.4286C20.6396 27.1431 20 26.5035 20 25.7146C20 24.9256 20.6396 24.286 21.4286 24.286H37.1429V15.7146H21.4286C20.6396 15.7146 20 15.075 20 14.286Z"
          fill="#C147E9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.836837 13.6943C1.37265 13.1585 2.09938 12.8574 2.85714 12.8574H7.14286C7.93183 12.8574 8.57143 13.497 8.57143 14.286C8.57143 15.075 7.93183 15.7146 7.14286 15.7146H2.85714V24.286H7.14286C7.93183 24.286 8.57143 24.9256 8.57143 25.7146C8.57143 26.5035 7.93183 27.1431 7.14286 27.1431H2.85714C2.09938 27.1431 1.37266 26.8421 0.836837 26.3063C0.301017 25.7705 0 25.0438 0 24.286V15.7146C0 14.9568 0.30102 14.2301 0.836837 13.6943Z"
          fill="#C147E9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 7.14293C10 6.35396 10.6396 5.71436 11.4286 5.71436H17.1429C17.9318 5.71436 18.5714 6.35396 18.5714 7.14293C18.5714 7.9319 17.9318 8.5715 17.1429 8.5715H11.4286C10.6396 8.5715 10 7.9319 10 7.14293Z"
          fill="#C147E9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 32.8573C10 32.0684 10.6396 31.4287 11.4286 31.4287H17.1429C17.9318 31.4287 18.5714 32.0684 18.5714 32.8573C18.5714 33.6461 17.9318 34.2859 17.1429 34.2859H11.4286C10.6396 34.2859 10 33.6461 10 32.8573Z"
          fill="#C147E9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2855 5.71436C15.0745 5.71436 15.7141 6.35396 15.7141 7.14293V32.8572C15.7141 33.6461 15.0745 34.2858 14.2855 34.2858C13.4965 34.2858 12.8569 33.6461 12.8569 32.8572V7.14293C12.8569 6.35396 13.4965 5.71436 14.2855 5.71436Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_431">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  News: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 40"
      fill="currentColor"
    >
      <path
        d="M36.0938 0H5C4.56852 0 4.21875 0.349844 4.21875 0.78125V6.71875H0.78125C0.349766 6.71875 0 7.06859 0 7.5V37.1094C0 38.7032 1.29672 40 2.89062 40H33.9844C35.5783 40 36.875 38.7033 36.875 37.1094V26.6373C36.875 26.2059 36.5252 25.8561 36.0938 25.8561C35.6623 25.8561 35.3125 26.2059 35.3125 26.6373V37.1094C35.3125 37.8417 34.7167 38.4375 33.9844 38.4375H5.4568C5.66359 38.0395 5.78125 37.588 5.78125 37.1094V1.5625H35.3125V19.6061C35.3125 20.0375 35.6623 20.3873 36.0938 20.3873C36.5252 20.3873 36.875 20.0375 36.875 19.6061V0.78125C36.875 0.349844 36.5252 0 36.0938 0ZM1.5625 37.1094V8.28125H4.21875V37.1094C4.21875 37.8417 3.62297 38.4375 2.89062 38.4375C2.15828 38.4375 1.5625 37.8417 1.5625 37.1094Z"
        fill="#C147E9"
      />
      <path
        d="M8.5201 11.6421C8.95158 11.6421 9.30135 11.2922 9.30135 10.8608V8.06443L11.4629 11.1945C11.688 11.5194 12.0649 11.6567 12.4235 11.5448C12.7882 11.4308 13.024 11.092 13.024 10.6818V5.54834C13.024 5.11693 12.6742 4.76709 12.2428 4.76709C11.8113 4.76709 11.4615 5.11693 11.4615 5.54834V8.44287L9.16291 5.11443C8.96861 4.83303 8.61393 4.71107 8.28752 4.81256C7.96111 4.91436 7.73877 5.21654 7.73877 5.55842V10.8609C7.73885 11.2922 8.08861 11.6421 8.5201 11.6421Z"
        fill="#C147E9"
      />
      <path
        d="M17.6062 6.32959C18.0377 6.32959 18.3874 5.97975 18.3874 5.54834C18.3874 5.11693 18.0377 4.76709 17.6062 4.76709H15.3677C14.9362 4.76709 14.5864 5.11693 14.5864 5.54834V10.8608C14.5864 11.2922 14.9362 11.6421 15.3677 11.6421H17.6062C18.0377 11.6421 18.3874 11.2922 18.3874 10.8608C18.3874 10.4294 18.0377 10.0796 17.6062 10.0796H16.1489V8.98592H17.4411C17.8726 8.98592 18.2224 8.63607 18.2224 8.20467C18.2224 7.77326 17.8726 7.42342 17.4411 7.42342H16.1489V6.32959H17.6062Z"
        fill="#C147E9"
      />
      <path
        d="M30.9782 10.0792C30.4828 10.0792 30.0071 9.88073 29.7058 9.54831C29.4161 9.22854 28.922 9.2044 28.6023 9.49417C28.2826 9.78393 28.2583 10.278 28.5481 10.5977C29.1495 11.2611 30.0352 11.6417 30.9782 11.6417C32.1546 11.6417 33.1433 10.8867 33.3291 9.84643C33.4696 9.05901 33.1182 8.03253 31.7099 7.51315C31.0776 7.27995 30.4875 7.02643 30.2857 6.93823C30.2021 6.86307 30.2009 6.76502 30.2088 6.70963C30.2191 6.63807 30.2728 6.46276 30.5492 6.37948C31.2343 6.17315 31.8815 6.67885 31.9033 6.6962C32.2336 6.96932 32.723 6.92549 32.9993 6.5969C33.2769 6.26659 33.2342 5.77385 32.9039 5.4962C32.8518 5.45229 31.61 4.42838 30.0985 4.88338C29.3209 5.11768 28.7706 5.73237 28.6622 6.4876C28.56 7.19901 28.8686 7.88354 29.4674 8.27385C29.5019 8.29635 29.5381 8.31604 29.5757 8.33284C29.6067 8.34667 30.3417 8.67385 31.1692 8.97901C31.3293 9.03807 31.8474 9.25542 31.7909 9.57174C31.7474 9.81573 31.4243 10.0792 30.9782 10.0792Z"
        fill="#C147E9"
      />
      <path
        d="M20.8513 11.0402C20.9783 11.4004 21.3189 11.6414 21.7002 11.6414C21.7022 11.6414 21.7043 11.6414 21.7063 11.6414C22.0901 11.6388 22.4304 11.3925 22.5531 11.0285C22.5554 11.0218 22.5576 11.015 22.5597 11.0082L23.4168 8.21847L24.27 11.0088C24.2732 11.0193 24.2767 11.0298 24.2803 11.0401C24.4074 11.4003 24.748 11.6414 25.1292 11.6414C25.1312 11.6414 25.1332 11.6414 25.1353 11.6413C25.5189 11.6388 25.8592 11.3925 25.9821 11.0287C25.9931 10.9965 26.0018 10.9635 26.0084 10.9301L27.0399 5.70862C27.1235 5.28534 26.8481 4.87441 26.4248 4.79081C26.0015 4.70753 25.5906 4.98253 25.5069 5.40589L24.9903 8.02112L24.1641 5.31917C24.0378 4.90652 23.601 4.67425 23.1885 4.8005C22.9102 4.88558 22.7145 5.11222 22.655 5.3773L21.8426 8.02167L21.3273 5.39698C21.2442 4.97362 20.8337 4.69784 20.4102 4.78089C19.9868 4.86394 19.711 5.27456 19.7941 5.698L20.8214 10.9307C20.8288 10.968 20.8388 11.0046 20.8513 11.0402Z"
        fill="#C147E9"
      />
      <path
        d="M7.73877 30.6216C7.73877 31.053 8.08854 31.4028 8.52002 31.4028H21.645C22.0765 31.4028 22.4263 31.053 22.4263 30.6216V15.6216C22.4263 15.1902 22.0765 14.8403 21.645 14.8403H8.52002C8.08854 14.8403 7.73877 15.1902 7.73877 15.6216V30.6216ZM9.30127 24.5902L11.6053 22.2862L13.246 23.9268C13.2462 23.9271 13.2464 23.9274 13.2467 23.9277C13.247 23.9279 13.2474 23.9281 13.2476 23.9285L19.1594 29.8403H9.30127V24.5902ZM20.8638 29.335L14.904 23.3753L18.0675 20.2118L20.8638 23.008V29.335ZM20.8638 16.4028V20.7982L18.62 18.5545C18.3149 18.2495 17.8203 18.2495 17.5151 18.5545L13.7992 22.2704L12.1577 20.6289C11.8526 20.3238 11.3579 20.3239 11.0528 20.6289L9.30127 22.3805V16.4028H20.8638Z"
        fill="#C147E9"
      />
      <path
        d="M32.5737 29.8403H25.5425C25.111 29.8403 24.7612 30.1902 24.7612 30.6216C24.7612 31.053 25.111 31.4028 25.5425 31.4028H32.5737C33.0052 31.4028 33.355 31.053 33.355 30.6216C33.355 30.1902 33.0052 29.8403 32.5737 29.8403Z"
        fill="#C147E9"
      />
      <path
        d="M32.5737 18.5903H25.5425C25.111 18.5903 24.7612 18.9402 24.7612 19.3716C24.7612 19.803 25.111 20.1528 25.5425 20.1528H32.5737C33.0052 20.1528 33.355 19.803 33.355 19.3716C33.355 18.9402 33.0052 18.5903 32.5737 18.5903Z"
        fill="#C147E9"
      />
      <path
        d="M32.5737 22.3403H25.5425C25.111 22.3403 24.7612 22.6902 24.7612 23.1216C24.7612 23.553 25.111 23.9028 25.5425 23.9028H32.5737C33.0052 23.9028 33.355 23.553 33.355 23.1216C33.355 22.6902 33.0052 22.3403 32.5737 22.3403Z"
        fill="#C147E9"
      />
      <path
        d="M32.5737 14.8403H25.5425C25.111 14.8403 24.7612 15.1902 24.7612 15.6216C24.7612 16.053 25.111 16.4028 25.5425 16.4028H32.5737C33.0052 16.4028 33.355 16.053 33.355 15.6216C33.355 15.1902 33.0052 14.8403 32.5737 14.8403Z"
        fill="#C147E9"
      />
      <path
        d="M32.5737 26.0903H25.5425C25.111 26.0903 24.7612 26.4402 24.7612 26.8716C24.7612 27.303 25.111 27.6528 25.5425 27.6528H32.5737C33.0052 27.6528 33.355 27.303 33.355 26.8716C33.355 26.4402 33.0052 26.0903 32.5737 26.0903Z"
        fill="#C147E9"
      />
      <path
        d="M8.52002 35.7812H32.5825C33.014 35.7812 33.3638 35.4314 33.3638 35C33.3638 34.5686 33.014 34.2188 32.5825 34.2188H8.52002C8.08854 34.2188 7.73877 34.5686 7.73877 35C7.73877 35.4314 8.08854 35.7812 8.52002 35.7812Z"
        fill="#C147E9"
      />
      <path
        d="M36.0938 22.3408C35.8875 22.3408 35.6867 22.4244 35.5414 22.5697C35.3961 22.715 35.3125 22.9158 35.3125 23.1221C35.3125 23.3275 35.3961 23.5291 35.5414 23.6744C35.6867 23.8196 35.8875 23.9033 36.0938 23.9033C36.2992 23.9033 36.5008 23.8197 36.6461 23.6744C36.7914 23.5291 36.875 23.3275 36.875 23.1221C36.875 22.9166 36.7914 22.715 36.6461 22.5697C36.5008 22.4244 36.2992 22.3408 36.0938 22.3408Z"
        fill="#C147E9"
      />
    </svg>
  ),
  Calendar: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <path
        d="M36.5912 6.02909H34.6129V4.60213C34.6129 3.36252 33.6044 2.354 32.3648 2.354C31.1251 2.354 30.1166 3.36252 30.1166 4.60213V6.02909H26.3697V4.60213C26.3697 3.36252 25.3611 2.354 24.1215 2.354C22.8819 2.354 21.8734 3.36252 21.8734 4.60213V6.02909H18.1265V4.60213C18.1266 3.36252 17.1181 2.354 15.8785 2.354C14.6389 2.354 13.6303 3.36252 13.6303 4.60213V6.02909H9.88346V4.60213C9.88346 3.36252 8.87494 2.354 7.63533 2.354C6.39572 2.354 5.3872 3.36252 5.3872 4.60213V6.02909H3.40876C1.52907 6.02909 0 7.55815 0 9.43785V11.5768C0 11.9493 0.301954 12.2512 0.674455 12.2512C1.04696 12.2512 1.34891 11.9493 1.34891 11.5768V9.43785C1.34891 8.30198 2.2729 7.378 3.40876 7.378H5.38712V8.93566C5.38712 10.1753 6.39564 11.1838 7.63525 11.1838C8.87486 11.1838 9.88338 10.1753 9.88338 8.93566V7.378H13.6303V8.93566C13.6303 10.1753 14.6388 11.1838 15.8784 11.1838C17.118 11.1838 18.1265 10.1753 18.1265 8.93566V7.378H21.8734V8.93566C21.8734 10.1753 22.8819 11.1838 24.1215 11.1838C25.3611 11.1838 26.3697 10.1753 26.3697 8.93566V7.378H30.1166V8.93566C30.1166 10.1753 31.1251 11.1838 32.3648 11.1838C33.6044 11.1838 34.6129 10.1753 34.6129 8.93566V7.378H36.5912C37.727 7.378 38.6511 8.30206 38.6511 9.43785V11.1511C38.6511 11.5236 38.953 11.8255 39.3255 11.8255C39.698 11.8255 40 11.5236 40 11.1511V9.43785C40 7.55815 38.4709 6.02909 36.5912 6.02909ZM8.53447 8.93566C8.53447 9.43152 8.13103 9.83488 7.63525 9.83488C7.13947 9.83488 6.73603 9.43144 6.73603 8.93566V4.60213C6.73603 4.10627 7.13947 3.70291 7.63525 3.70291C8.13103 3.70291 8.53447 4.10635 8.53447 4.60213V8.93566ZM16.7778 8.93566C16.7778 8.96667 16.7761 8.99722 16.7731 9.02745C16.73 9.45011 16.393 9.78714 15.9703 9.83019C15.9401 9.83324 15.9096 9.83488 15.8785 9.83488C15.8475 9.83488 15.817 9.83324 15.7868 9.83019C15.364 9.78714 15.0271 9.45011 14.984 9.02745C14.981 8.99722 14.9793 8.96667 14.9793 8.93566V4.60213C14.9793 4.10627 15.3828 3.70291 15.8785 3.70291C16.3744 3.70291 16.7778 4.10635 16.7778 4.60213V8.93566ZM25.0208 8.93566C25.0208 8.96667 25.0192 8.99722 25.0161 9.02745C24.9731 9.45011 24.6361 9.78714 24.2134 9.83019C24.1832 9.83324 24.1526 9.83488 24.1216 9.83488C24.0906 9.83488 24.06 9.83324 24.0298 9.83019C23.6071 9.78714 23.2701 9.45011 23.2271 9.02745C23.224 8.99722 23.2224 8.96667 23.2224 8.93566V4.60213C23.2224 4.10627 23.6258 3.70291 24.1216 3.70291C24.6175 3.70291 25.0208 4.10635 25.0208 4.60213V8.93566ZM33.264 8.93566C33.264 8.96667 33.2623 8.99722 33.2593 9.02745C33.2162 9.45011 32.8792 9.78714 32.4566 9.83019C32.4263 9.83324 32.3958 9.83488 32.3648 9.83488C32.3337 9.83488 32.3032 9.83324 32.273 9.83019C31.8502 9.78714 31.5133 9.45011 31.4702 9.02745C31.4672 8.99722 31.4655 8.96667 31.4655 8.93566V4.60213C31.4655 4.10627 31.869 3.70291 32.3648 3.70291C32.8606 3.70291 33.264 4.10635 33.264 4.60213V8.93566Z"
        fill="#C147E9"
      />
      <path
        d="M39.3255 13.1743C38.953 13.1743 38.6511 13.4763 38.6511 13.8488V15.8239H1.34891V14.2745C1.34891 13.902 1.04696 13.6 0.674455 13.6C0.301954 13.6 0 13.902 0 14.2745V33.5734C0 35.8188 1.82672 37.6455 4.07212 37.6455H35.9279C38.1732 37.6455 40 35.8188 40 33.5734V13.8488C40 13.4763 39.698 13.1743 39.3255 13.1743ZM6.96087 36.2966H4.07212C2.57055 36.2966 1.34891 35.075 1.34891 33.5734V30.4868H6.96087V36.2966ZM6.96087 29.1379H1.34891V23.765H6.96087V29.1379ZM6.96087 22.4161H1.34891V17.1728H6.96087V22.4161ZM15.204 36.2966H8.30978V30.4868H15.204V36.2966ZM15.204 29.1379H8.30978V23.765H15.204V29.1379ZM15.204 22.4161H8.30978V17.1728H15.204V22.4161ZM23.4472 36.2966H16.5529V30.4868H23.4472V36.2966ZM23.4472 29.1379H16.5529V23.765H23.4472V29.1379ZM23.4472 22.4161H16.5529V17.1728H23.4472V22.4161ZM31.6904 36.2966H24.7961V30.4868H31.6904V36.2966ZM31.6904 29.1379H24.7961V23.765H31.6904V29.1379ZM31.6904 22.4161H24.7961V17.1728H31.6904V22.4161ZM38.6511 33.5734C38.6511 35.075 37.4295 36.2966 35.9279 36.2966H33.0392V30.4868H38.6511V33.5734ZM38.6511 29.1379H33.0392V23.765H38.6511V29.1379ZM38.6511 22.4161H33.0392V17.1728H38.6511V22.4161Z"
        fill="#C147E9"
      />
    </svg>
  ),
  CalendarFlip: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1162_317)">
        <path
          d="M40 14.551V14.3445C40 11.6989 37.922 9.53023 35.3125 9.38344V0H4.6875V9.38352C2.07805 9.53031 0 11.699 0 14.3445C0 15.1062 0.178906 15.8696 0.517344 16.5522L4.55133 24.6875L0.517266 32.8228C0.178906 33.5054 0 34.2688 0 35.0305C0 37.7707 2.2293 40 4.96953 40H35.0305C37.7707 40 40 37.7707 40 35.0305V34.8239C40 34.2305 39.8951 33.6477 39.6884 33.0916L36.5628 24.6875L39.6883 16.2834C39.8951 15.7273 40 15.1445 40 14.551ZM32.9688 2.34375V9.375H7.03125V2.34375H32.9688ZM37.6562 14.551C37.6562 14.8646 37.6009 15.1725 37.4916 15.4663L34.0622 24.6875L37.4916 33.9088C37.6008 34.2025 37.6562 34.5104 37.6562 34.824V35.0305C37.6562 36.4784 36.4783 37.6563 35.0305 37.6563H4.96953C3.52164 37.6562 2.34375 36.4784 2.34375 35.0305C2.34375 34.628 2.43828 34.2246 2.61711 33.864L7.16742 24.6875L2.61711 15.5111C2.43828 15.1504 2.34375 14.747 2.34375 14.3445C2.34375 12.8966 3.52164 11.7188 4.96953 11.7188H35.0305C36.4784 11.7188 37.6562 12.8966 37.6562 14.3445V14.551Z"
          fill="#C147E9"
        />
        <path d="M9.375 4.6875H11.7188V7.03125H9.375V4.6875Z" fill="#C147E9" />
        <path d="M28.2812 4.6875H30.625V7.03125H28.2812V4.6875Z" fill="#C147E9" />
        <path d="M23.1641 17.583H25.5078V34.1455H27.8516V15.2393H23.1641V17.583Z" fill="#C147E9" />
        <path
          d="M21.6015 20.5518C21.6015 17.6225 19.2183 15.2393 16.289 15.2393C13.7561 15.2393 11.5637 17.041 11.0762 19.5233L13.376 19.975C13.6483 18.589 14.8734 17.583 16.2891 17.583C17.926 17.583 19.2578 18.9148 19.2578 20.5518C19.2578 22.1887 17.926 23.5205 16.2891 23.5205V25.8643C17.926 25.8643 19.2578 27.1961 19.2578 28.833C19.2578 30.47 17.926 31.8018 16.2891 31.8018C14.8161 31.8018 13.5521 30.7041 13.3491 29.2486C13.33 29.1121 13.3203 28.9722 13.3203 28.833H10.9766C10.9766 29.0802 10.9937 29.3289 11.0277 29.5725C11.3916 32.1795 13.6534 34.1455 16.2891 34.1455C19.2184 34.1455 21.6016 31.7623 21.6016 28.833C21.6016 27.161 20.8252 25.6669 19.6139 24.6924C20.8251 23.7178 21.6015 22.2238 21.6015 20.5518Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_317">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Youtube: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 30"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1162_309)">
        <path
          d="M15.6346 7.4685C15.5177 7.46578 15.4014 7.48645 15.2926 7.52931C15.1838 7.57217 15.0847 7.63635 15.001 7.71808C14.9174 7.79981 14.8509 7.89743 14.8055 8.00521C14.7602 8.11299 14.7368 8.22875 14.7368 8.34569V20.6264C14.7369 20.7807 14.7777 20.9322 14.8551 21.0656C14.9324 21.1991 15.0436 21.3098 15.1774 21.3866C15.3112 21.4634 15.4629 21.5036 15.6171 21.5031C15.7714 21.5026 15.9228 21.4614 16.0561 21.3837L26.5833 15.2432C26.7155 15.1659 26.8252 15.0553 26.9014 14.9225C26.9776 14.7896 27.0177 14.6391 27.0177 14.486C27.0177 14.3328 26.9776 14.1823 26.9014 14.0494C26.8252 13.9166 26.7155 13.806 26.5833 13.7287L16.0561 7.58824C15.928 7.51325 15.783 7.47218 15.6346 7.4685ZM16.4913 9.87227L24.4003 14.4862L16.4913 19.1002V9.87227Z"
          fill="#C147E9"
        />
        <path
          d="M9.47408 0.451172C4.62961 0.451172 0.702148 4.37863 0.702148 9.2231V19.7494C0.702148 24.5939 4.62961 28.5213 9.47408 28.5213H30.5267C35.3712 28.5213 39.2986 24.5939 39.2986 19.7494V9.2231C39.2986 4.37863 35.3712 0.451172 30.5267 0.451172H9.47408ZM9.47408 2.20556H30.5267C34.4296 2.20556 37.5443 5.32021 37.5443 9.2231V19.7494C37.5443 23.6523 34.4296 26.767 30.5267 26.767H9.47408C5.57118 26.767 2.45653 23.6523 2.45653 19.7494V9.2231C2.45653 5.32021 5.57118 2.20556 9.47408 2.20556Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_309">
          <rect width="40" height="29.4737" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Vimeo: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1162_314)">
        <path
          d="M21.9866 23.2332C20.4382 21.4832 18.9982 10.5532 18.8932 10.0165C17.9082 3.73983 14.6899 2.70816 12.1566 2.9565C9.03492 3.24983 4.86492 7.62316 0.423249 11.5415C-0.070084 11.9782 -0.141751 12.7215 0.261583 13.2432L2.02658 15.5248C2.43492 16.0548 3.18825 16.1698 3.73325 15.7848C5.21825 14.7415 5.83992 14.3832 6.07992 14.2615C9.37825 15.3615 9.46658 37.5265 18.1132 37.5265C26.6866 37.5265 46.2183 13.0848 38.0866 4.39316C34.9716 1.05983 25.0066 0.77983 21.5149 12.1915C21.2016 13.2165 22.2466 14.1332 23.2166 13.6998C23.9716 13.3648 24.7349 13.1948 25.4849 13.1948C26.5933 13.1948 26.6749 13.6115 26.7349 13.9165C27.2416 16.4948 23.3883 22.2098 21.9866 23.2332ZM29.2732 14.3565C29.2732 13.2748 28.9632 12.3982 28.3516 11.7548C27.5416 10.9032 26.2049 10.5782 24.7132 10.7332C27.7016 4.00983 34.4799 4.1965 36.2599 6.09983C42.1149 12.3682 25.3599 35.0248 18.1116 35.0248C11.6699 35.0248 12.2666 11.7382 5.95158 11.7382C5.52825 11.7382 5.08325 11.8415 3.27825 13.0582L2.95158 12.6382C5.49158 10.3482 10.2949 5.64483 12.3932 5.44816C16.4532 5.03983 16.3682 11.0815 16.5866 11.4848C18.1832 22.2165 19.5382 25.8398 21.9516 25.8398C24.4832 25.8365 29.2732 18.3265 29.2732 14.3565Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_314">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Website: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1162_416)">
        <path
          d="M18.6667 37.3333C21.3029 37.3387 23.9096 36.7784 26.3107 35.69L27.4607 38.8353C27.5823 39.1705 27.8025 39.461 28.0921 39.6688C28.3818 39.8767 28.7276 39.9921 29.084 40H29.1333C29.4817 40.0013 29.8226 39.8995 30.1134 39.7076C30.4041 39.5157 30.6316 39.2422 30.7673 38.9213L32.0893 35.838L34.6733 38.4213C35.0463 38.793 35.5514 39.0017 36.078 39.0017C36.6046 39.0017 37.1097 38.793 37.4827 38.4213L38.4253 37.488C38.7983 37.1141 39.0078 36.6075 39.0078 36.0793C39.0078 35.5512 38.7983 35.0446 38.4253 34.6707L35.8413 32.0867L38.9247 30.7653C39.2515 30.6249 39.5286 30.3894 39.7199 30.0895C39.9113 29.7897 40.0081 29.4392 39.9979 29.0836C39.9876 28.728 39.8707 28.3837 39.6623 28.0954C39.4539 27.8071 39.1637 27.588 38.8293 27.4667L35.688 26.3173C36.7774 23.9142 37.3385 21.3052 37.3333 18.6667C37.3333 14.9748 36.2386 11.3657 34.1874 8.29603C32.1363 5.22631 29.221 2.83376 25.8101 1.42092C22.3992 0.00808811 18.646 -0.361574 15.025 0.358683C11.404 1.07894 8.07793 2.85677 5.46735 5.46735C2.85677 8.07793 1.07894 11.404 0.358683 15.025C-0.361574 18.646 0.00808811 22.3992 1.42092 25.8101C2.83376 29.221 5.22631 32.1363 8.29603 34.1874C11.3657 36.2386 14.9748 37.3333 18.6667 37.3333ZM5.34734 29.7453C7.11685 29.2613 8.91328 28.8818 10.7273 28.6087C11.6487 31.5887 12.9787 33.986 14.574 35.5073C10.9606 34.6248 7.72614 32.6049 5.34734 29.7453ZM27.992 18C27.9613 15.3108 27.6188 12.6343 26.9713 10.024C28.9598 9.719 30.927 9.28904 32.8613 8.73667C34.7745 11.4583 35.8589 14.6756 35.9833 18H27.992ZM24.17 22.1007C23.8806 21.9951 23.5671 21.9744 23.2664 22.0411C22.9656 22.1078 22.6903 22.2591 22.4727 22.4772C22.2551 22.6952 22.1044 22.971 22.0384 23.2718C21.9724 23.5727 21.9937 23.8862 22.1 24.1753L23.0813 26.8587C21.8347 26.76 20.584 26.6967 19.3333 26.6827V19.3333H26.6553C26.6351 20.5325 26.5534 21.7299 26.4107 22.9207L24.17 22.1007ZM18 26.6893C15.9006 26.7136 13.8043 26.8579 11.7213 27.1213C11.0641 24.5762 10.7128 21.9617 10.6747 19.3333H18V26.6893ZM18 28.0227V35.9333C15.586 35.478 13.438 32.582 12.1007 28.4207C14.0583 28.1794 16.0277 28.047 18 28.0227ZM19.3333 35.9333V28.0153C20.752 28.032 22.172 28.104 23.584 28.2327L24.4353 30.5607C23.0713 33.6607 21.2487 35.5693 19.3333 35.9333ZM26.6587 18H19.3333V10.6553C21.4334 10.6303 23.5302 10.484 25.6133 10.2173C26.2697 12.7608 26.6206 15.3735 26.6587 18ZM19.3333 9.32201V1.40001C21.7487 1.85601 23.8973 4.75401 25.2353 8.91934C23.277 9.16279 21.3066 9.29722 19.3333 9.32201ZM18 1.40001V9.32201C16.0268 9.2981 14.0564 9.16456 12.098 8.92201C13.436 4.75534 15.5847 1.85734 18 1.40001ZM18 10.654V18H10.6747C10.7128 15.3735 11.0637 12.7608 11.72 10.2173C13.8032 10.484 15.9 10.6303 18 10.6553V10.654ZM9.34134 18H1.35001C1.4745 14.6756 2.55882 11.4583 4.47201 8.73667C6.40636 9.28904 8.37359 9.719 10.362 10.024C9.71454 12.6343 9.37203 15.3108 9.34134 18ZM9.34134 19.3333C9.37193 22.0253 9.71512 24.7046 10.364 27.3173C8.37577 27.62 6.40871 28.0484 4.47468 28.6C2.55996 25.8777 1.47468 22.6592 1.35001 19.3333H9.34134ZM22.712 35.5253C23.6678 34.5875 24.4657 33.5013 25.0747 32.3087L25.8513 34.4333C24.8429 34.8986 23.7915 35.2644 22.712 35.5253ZM38.6667 29.12C38.6715 29.2091 38.6484 29.2976 38.6006 29.373C38.5528 29.4484 38.4827 29.507 38.4 29.5407L34.4113 31.2493C34.311 31.292 34.2227 31.3586 34.1542 31.4433C34.0856 31.528 34.0388 31.6283 34.0179 31.7352C33.9971 31.8422 34.0028 31.9527 34.0345 32.057C34.0663 32.1612 34.1231 32.2561 34.2 32.3333L37.48 35.6127C37.6038 35.7364 37.6733 35.9043 37.6733 36.0793C37.6733 36.2544 37.6038 36.4222 37.48 36.546L36.5373 37.4793C36.4145 37.602 36.248 37.6709 36.0743 37.6709C35.9007 37.6709 35.7342 37.602 35.6113 37.4793L32.3333 34.2C32.2563 34.123 32.1616 34.066 32.0575 34.0341C31.9533 34.0022 31.843 33.9963 31.736 34.0168C31.629 34.0374 31.5288 34.0839 31.4439 34.1522C31.3591 34.2205 31.2923 34.3086 31.2493 34.4087L29.5413 38.4C29.5063 38.482 29.4474 38.5515 29.3724 38.5997C29.2974 38.6479 29.2097 38.6725 29.1206 38.6703C29.0315 38.6682 28.945 38.6394 28.8724 38.5876C28.7998 38.5359 28.7444 38.4636 28.7133 38.38L23.3527 23.7173C23.3323 23.6662 23.3278 23.6102 23.3397 23.5564C23.3516 23.5027 23.3793 23.4538 23.4193 23.416C23.4437 23.3904 23.473 23.3699 23.5054 23.3557C23.5378 23.3415 23.5726 23.3339 23.608 23.3333C23.6429 23.3338 23.6774 23.3403 23.71 23.3527L38.3767 28.7187C38.4608 28.7471 38.5339 28.801 38.5858 28.873C38.6378 28.9449 38.6661 29.0313 38.6667 29.12ZM27.6947 23.3907C27.8683 22.0448 27.9665 20.6902 27.9887 19.3333H35.9813C35.9016 21.5887 35.3757 23.8058 34.434 25.8567L27.6947 23.3907ZM31.9913 7.59467C30.2209 8.0789 28.4236 8.45911 26.6087 8.73334C25.6867 5.74867 24.356 3.34801 22.7593 1.82601C26.3757 2.70912 29.6123 4.73152 31.9913 7.59467ZM14.574 1.82601C12.9773 3.34801 11.6467 5.74867 10.7247 8.73334C8.90981 8.45955 7.11251 8.07979 5.34201 7.59601C7.7209 4.73236 10.9575 2.70948 14.574 1.82601Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1162_416">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Books: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_853)">
        <mask
          id="mask0_1195_853"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_853)">
          <path
            d="M24.8178 20H8.75C4.34898 20 0.78125 16.4323 0.78125 12.0312C0.78125 7.63023 4.34898 4.0625 8.75 4.0625H16.4845"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.25 16.5625H37.4999C38.4492 16.5625 39.2187 17.332 39.2187 18.2813C39.2187 19.2305 38.4492 20 37.4999 20H31.25"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.5165 4.0625H37.5008C38.45 4.0625 39.2195 4.83203 39.2195 5.78125C39.2195 6.73047 38.45 7.5 37.5008 7.5H8.77051C6.26793 7.5 4.23926 9.52867 4.23926 12.0313C4.23926 14.5338 6.26793 16.5625 8.77051 16.5625H24.8707"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.4688 7.5V16.5625"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.1198 23.4375H31.2303C33.7328 23.4375 35.7616 25.4662 35.7616 27.9688C35.7616 30.4713 33.7328 32.5 31.2303 32.5H2.5C1.55078 32.5 0.78125 33.2695 0.78125 34.2188C0.78125 35.168 1.55078 35.9375 2.5 35.9375H31.25C35.651 35.9375 39.2188 32.3698 39.2188 27.9688C39.2188 23.5677 35.651 20 31.25 20H31.1198"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.8178 20H2.5C1.55078 20 0.78125 20.7695 0.78125 21.7188C0.78125 22.668 1.55078 23.4375 2.5 23.4375H24.9791"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.53125 23.4375V32.5"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.1201 10.9372V26.1489L28.0498 23.4372L24.9795 26.1489V10.9372"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.0703 10.9375H35.0006"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.3125 13.125H16.4069"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.75977 26.875H10.5218"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9219 29.0625H20.6771"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_853">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Bank: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_747)">
        <path
          d="M20.001 7.8125C19.5697 7.8125 19.2197 8.1625 19.2197 8.59375C19.2197 9.025 19.5697 9.375 20.001 9.375C20.4322 9.375 20.7822 9.025 20.7822 8.59375C20.7822 8.1625 20.4322 7.8125 20.001 7.8125Z"
          fill="#C147E9"
        />
        <path
          d="M39.6052 11.0397L20.3864 0.102187C20.1469 -0.0340624 19.8532 -0.0340624 19.6136 0.102187L0.394843 11.0397C0.111484 11.201 0.0319531 11.4125 0 11.7242C0 11.7247 0 11.7254 0 11.7259V14.8436C0 16.136 1.0514 17.1874 2.34375 17.1874H3.59374V19.5311C3.59374 19.9625 3.94359 20.3124 4.37499 20.3124H5.15624V30.6249H4.37507C3.94366 30.6249 3.59382 30.9747 3.59382 31.4061V33.7499H2.34382C1.05148 33.7499 7.81249e-05 34.8013 7.81249e-05 36.0936V39.2186C7.81249e-05 39.65 0.349921 39.9998 0.781327 39.9998H39.2188C39.6502 39.9998 40 39.65 40 39.2186V36.0936C40 34.8013 38.9486 33.7499 37.6563 33.7499H36.4063V31.4061C36.4063 30.9747 36.0564 30.6249 35.625 30.6249H34.8438V20.3124H35.625C36.0564 20.3124 36.4063 19.9625 36.4063 19.5311V17.1874H37.6563C38.9486 17.1874 40 16.136 40 14.8436V11.7258C40 11.7253 40 11.7247 40 11.7241V11.7186C40 11.4419 39.8485 11.1782 39.6052 11.0397ZM20 1.68008L36.2665 10.9374H3.73359L20 1.68008ZM37.6563 35.3124C38.087 35.3124 38.4375 35.6628 38.4375 36.0936V38.4373H1.56258V36.0936C1.56258 35.6628 1.91304 35.3124 2.34382 35.3124H37.6563ZM16.0938 20.3124H16.875V30.6249H16.0938C15.6624 30.6249 15.3125 30.9747 15.3125 31.4061V33.7499H12.9688V31.4061C12.9688 30.9747 12.619 30.6249 12.1876 30.6249H11.4063V20.3124H12.1876C12.619 20.3124 12.9688 19.9625 12.9688 19.5311V17.1874H15.3125V19.5311C15.3125 19.9625 15.6624 20.3124 16.0938 20.3124ZM27.8125 20.3124H28.5938V30.6249H27.8125C27.3811 30.6249 27.0313 30.9747 27.0313 31.4061V33.7499H24.6875V31.4061C24.6875 30.9747 24.3377 30.6249 23.9063 30.6249H23.125V20.3124H23.9063C24.3377 20.3124 24.6875 19.9625 24.6875 19.5311V17.1874H27.0313V19.5311C27.0313 19.9625 27.3811 20.3124 27.8125 20.3124ZM34.8438 32.1874V33.7499H28.5938V32.1874H34.8438ZM30.1563 30.6249V20.3124H33.2813V30.6249H30.1563ZM23.125 18.7499H16.875V17.1874H23.125V18.7499ZM21.5625 20.3124V30.6249H18.4375V20.3124H21.5625ZM23.125 32.1874V33.7499H16.875V32.1874H23.125ZM11.4063 18.7499H5.15632V17.1874H11.4063V18.7499ZM9.84381 20.3124V30.6249H6.71882V20.3124H9.84381ZM11.4063 32.1874V33.7499H5.15632V32.1874H11.4063ZM34.8438 18.7499H28.5938V17.1874H34.8438V18.7499ZM38.4375 14.8436C38.4375 15.2743 38.087 15.6249 37.6563 15.6249H2.34382C1.91304 15.6249 1.56258 15.2744 1.56258 14.8436V12.4999H38.4375V14.8436Z"
          fill="#C147E9"
        />
        <path
          d="M26.251 7.8125H23.126C22.6946 7.8125 22.3447 8.16234 22.3447 8.59375C22.3447 9.02515 22.6946 9.375 23.126 9.375H26.251C26.6824 9.375 27.0322 9.02515 27.0322 8.59375C27.0322 8.16234 26.6824 7.8125 26.251 7.8125Z"
          fill="#C147E9"
        />
        <path
          d="M16.876 7.8125H13.751C13.3196 7.8125 12.9697 8.16234 12.9697 8.59375C12.9697 9.02515 13.3196 9.375 13.751 9.375H16.876C17.3074 9.375 17.6572 9.02515 17.6572 8.59375C17.6572 8.16234 17.3074 7.8125 16.876 7.8125Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1195_747">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Healthcare: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_791)">
        <mask
          id="mask0_1195_791"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_791)">
          <path
            d="M23.2812 4.0625C23.2812 5.87469 21.8122 7.34375 20 7.34375C18.1878 7.34375 16.7188 5.87469 16.7188 4.0625C16.7188 2.25031 18.1878 0.78125 20 0.78125C21.8122 0.78125 23.2812 2.25031 23.2812 4.0625Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.875 7.07032V32.4494C21.875 34.8341 21.2269 37.1739 20 39.2188C18.7731 37.1739 18.125 34.8341 18.125 32.4494V7.07032"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.125 8.90625H17.3762C15.9473 8.90625 14.6201 8.1675 13.8672 6.95313C13.1143 5.73875 11.787 5 10.3582 5H0.781254C0.778129 7.07016 2.4554 8.75 4.52555 8.75H10"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.19824 8.75C4.19824 10.4759 5.59738 11.875 7.32324 11.875H10.8241"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.35547 11.875C8.35547 13.6009 9.75461 15 11.4805 15H17.6828"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.3632 5H39.2188C39.2219 7.07016 37.5445 8.75 35.4744 8.75H30"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.875 8.90625H22.6238C24.0527 8.90625 25.3799 8.1675 26.1328 6.95313C26.8857 5.73875 28.213 5 29.6418 5H30.332"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.8026 8.75C35.8026 10.4759 34.4035 11.875 32.6776 11.875H29.1768"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.6457 11.875C31.6457 13.6009 30.2466 15 28.5207 15H22.3184"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.1483 28.7236H24.8698C26.2146 28.7236 27.3047 27.6335 27.3047 26.2887C27.3047 24.9439 26.2146 23.8539 24.8698 23.8539H14.5834C13.0013 23.8539 11.7188 22.5713 11.7188 20.9893C11.7188 19.4072 13.0013 18.1246 14.5834 18.1246H14.6484"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.6761 37.9351H23.6754C24.939 37.9351 25.9634 36.9107 25.9634 35.6471C25.9634 34.3835 24.939 33.3591 23.6754 33.3591H16.388C15.108 33.3591 14.0703 32.3215 14.0703 31.0415C14.0703 29.7614 15.108 28.7237 16.388 28.7237H17.8514"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_791">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  House: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_719)">
        <path
          d="M35.5523 27.8852C35.407 27.7398 35.2055 27.6562 35 27.6562C34.7945 27.6562 34.593 27.7398 34.4477 27.8852C34.3023 28.0305 34.2188 28.2312 34.2188 28.4375C34.2188 28.643 34.3023 28.8445 34.4477 28.9898C34.593 29.1351 34.7945 29.2188 35 29.2188C35.2055 29.2188 35.407 29.1352 35.5523 28.9898C35.6977 28.8445 35.7812 28.643 35.7812 28.4375C35.7812 28.232 35.6977 28.0305 35.5523 27.8852Z"
          fill="#C147E9"
        />
        <path
          d="M39.2188 38.4374H35.7812V31.1718C35.7812 30.7404 35.4314 30.3906 35 30.3906C34.5686 30.3906 34.2188 30.7404 34.2188 31.1718V38.4374H9.53125V31.0937C9.53125 30.6623 9.18141 30.3124 8.75 30.3124C8.31859 30.3124 7.96875 30.6623 7.96875 31.0937V38.4374H5.78125V17.8907L20 6.79018L34.2188 17.8907V25.3124C34.2188 25.7438 34.5686 26.0937 35 26.0937C35.4314 26.0937 35.7812 25.7438 35.7812 25.3124V19.1106L35.9178 19.2172C36.0598 19.3281 36.2294 19.3827 36.3983 19.3827C36.5992 19.3827 36.7994 19.3054 36.9509 19.1538L39.7688 16.3359C39.927 16.1776 40.0098 15.959 39.9962 15.7356C39.9824 15.5121 39.8736 15.3053 39.6971 15.1676L35 11.5006V3.67182C35 3.24033 34.6502 2.89057 34.2188 2.89057H29.6908C29.2594 2.89057 28.9095 3.24033 28.9095 3.67182V6.74572L20.4807 0.16541C20.1983 -0.0551367 19.8017 -0.0551367 19.5192 0.16541L0.302812 15.1676C0.126328 15.3053 0.0175 15.5121 0.00375 15.7356C-0.00992187 15.959 0.0728906 16.1775 0.231094 16.3359L3.04898 19.1538C3.32789 19.4327 3.77117 19.46 4.08219 19.2172L4.21875 19.1106V38.4374H0.78125C0.349844 38.4374 0 38.7873 0 39.2187C0 39.6501 0.349844 39.9999 0.78125 39.9999H39.2188C39.6502 39.9999 40 39.6501 40 39.2187C40 38.7873 39.6502 38.4374 39.2188 38.4374ZM30.472 4.45307H33.4375V10.2807L30.472 7.96557V4.45307ZM3.66531 17.5604L1.96063 15.8556L20 1.77229L38.0394 15.8556L36.3347 17.5604L20.4807 5.18322C20.3395 5.07291 20.1698 5.01775 20 5.01775C19.8302 5.01775 19.6605 5.07291 19.5193 5.18322L3.66531 17.5604Z"
          fill="#C147E9"
        />
        <path
          d="M27.5 17.0312H12.5C12.0686 17.0312 11.7188 17.381 11.7188 17.8125V32.8125C11.7188 33.2439 12.0686 33.5938 12.5 33.5938H27.5C27.9314 33.5938 28.2812 33.2439 28.2812 32.8125V17.8125C28.2812 17.381 27.9314 17.0312 27.5 17.0312ZM19.2188 32.0312H13.2812V26.0938H19.2188V32.0312ZM19.2188 24.5312H13.2812V18.5938H19.2188V24.5312ZM26.7188 32.0312H20.7812V26.0938H26.7188V32.0312ZM26.7188 24.5312H20.7812V18.5938H26.7188V24.5312Z"
          fill="#C147E9"
        />
        <path
          d="M8.75 27.2271C8.31859 27.2271 7.96875 27.5768 7.96875 28.0083V28.0209C7.96875 28.4523 8.31859 28.8021 8.75 28.8021C9.18141 28.8021 9.53125 28.4523 9.53125 28.0209V28.0083C9.53125 27.5769 9.18141 27.2271 8.75 27.2271Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1195_719">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Cutlery: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_475)">
        <path
          d="M35.545 3.36364C35.2645 3.08333 34.8098 3.0831 34.5291 3.36364L27.0816 10.811C26.8009 11.0915 26.8009 11.5462 27.0815 11.8268C27.2218 11.9671 27.4056 12.0372 27.5895 12.0372C27.7732 12.0372 27.9571 11.9671 28.0974 11.8268L35.545 4.3795C35.8255 4.09888 35.8255 3.64411 35.545 3.36364Z"
          fill="#C147E9"
        />
        <path
          d="M37.5702 5.35727C37.2896 5.07688 36.8349 5.07688 36.5543 5.35727L29.1068 12.8048C28.8264 13.0854 28.8264 13.5401 29.1068 13.8206C29.2471 13.9609 29.431 14.0309 29.6147 14.0309C29.7985 14.0309 29.9824 13.9609 30.1227 13.8206L37.5702 6.37305C37.8508 6.0925 37.8508 5.63773 37.5702 5.35727Z"
          fill="#C147E9"
        />
        <path
          d="M30.5443 17.9333L39.7894 8.6881C40.07 8.40747 40.07 7.95278 39.7894 7.67224C39.5088 7.39192 39.0541 7.39169 38.7736 7.67224L29.5286 16.9174C28.3896 18.0563 26.648 18.3551 25.195 17.6612C24.9059 17.5233 24.5608 17.593 24.3482 17.8325L21.2069 21.3718C21.2056 21.3732 21.2042 21.3743 21.203 21.3758C21.2017 21.3772 21.2008 21.3786 21.1995 21.38L7.62227 36.6767C7.61883 36.6806 7.61539 36.6846 7.61203 36.6886C7.56727 36.7411 7.525 36.7873 7.48219 36.8302C6.5857 37.7266 5.12711 37.7265 4.23102 36.8302C3.7968 36.3961 3.55766 35.8186 3.55766 35.2046C3.55766 34.5905 3.7968 34.0132 4.2318 33.5782C4.27352 33.5362 4.31961 33.4941 4.37266 33.449C4.37672 33.4456 4.38062 33.4422 4.38453 33.4387L12.8727 25.9048C13.1694 25.6415 13.1963 25.1875 12.933 24.8908C12.6697 24.594 12.2156 24.5669 11.9191 24.8304L3.43656 32.3593C3.35547 32.4285 3.28289 32.4954 3.21523 32.5632C2.50969 33.2687 2.12109 34.2068 2.12109 35.2046C2.12109 36.2023 2.50961 37.1404 3.21516 37.846C3.94352 38.5742 4.9 38.9383 5.85672 38.9383C6.81305 38.9383 7.76977 38.5743 8.49758 37.8464C8.56656 37.7775 8.63336 37.7049 8.70195 37.6246L19.0482 25.9679L29.3946 37.6247C29.4631 37.7051 29.5299 37.7778 29.5984 37.8461C30.3266 38.5743 31.2832 38.9384 32.2398 38.9384C33.1964 38.9384 34.153 38.5743 34.8813 37.8461C36.3376 36.3896 36.3376 34.0199 34.8817 32.5638C34.813 32.4948 34.7402 32.428 34.66 32.3595L22.7544 21.7923L25.0837 19.1679C26.971 19.8366 29.1065 19.3708 30.5443 17.9333ZM33.7119 33.4388C33.7158 33.4422 33.7198 33.4457 33.7237 33.449C33.7763 33.4938 33.8225 33.5361 33.8654 33.5789C34.7617 34.4753 34.7617 35.9338 33.8655 36.83C32.969 37.7264 31.5105 37.7264 30.6137 36.8297C30.5713 36.7872 30.5289 36.741 30.4841 36.6884C30.4808 36.6844 30.4773 36.6804 30.4739 36.6765L20.0085 24.8858L21.8006 22.8666L33.7119 33.4388Z"
          fill="#C147E9"
        />
        <path
          d="M33.389 1.27182C33.1084 0.991426 32.6537 0.991426 32.3731 1.27182L23.1281 10.5171C21.6902 11.9549 21.2245 14.0901 21.8932 15.9778L19.0483 18.5029L16.3141 16.076C17.728 13.2938 17.2119 9.9158 14.9686 7.67244C12.7406 5.44447 10.16 3.87658 7.7021 3.25775C5.13624 2.61189 2.9364 3.04307 1.50718 4.47221C0.0779605 5.90135 -0.353289 8.1015 0.292726 10.6672C0.911633 13.1249 2.47945 15.7056 4.70757 17.9335C6.95085 20.1769 10.3288 20.6931 13.1112 19.279C13.1112 19.279 15.785 22.2913 15.8189 22.3296C15.9609 22.4896 16.1581 22.571 16.3564 22.571C16.526 22.571 16.6962 22.5113 16.833 22.3899L23.2287 16.7131C23.4682 16.5005 23.538 16.1552 23.4001 15.8663C22.706 14.4131 23.0049 12.6717 24.1439 11.5328L33.389 2.28768C33.6695 2.00705 33.6695 1.55236 33.389 1.27182ZM16.4165 20.8389L13.8018 17.8931C13.5702 17.6323 13.1844 17.5753 12.8876 17.7586C10.5846 19.1787 7.63851 18.8331 5.7232 16.9178C3.67601 14.8706 2.24218 12.5263 1.6857 10.3164C1.16812 8.26041 1.46546 6.54557 2.52304 5.48807C3.58046 4.43041 5.2953 4.13322 7.35124 4.65088C9.56116 5.20728 11.9056 6.64104 13.9526 8.68822C15.868 10.6035 16.2136 13.5496 14.7934 15.8525C14.6103 16.1495 14.6671 16.5351 14.928 16.7667L17.9661 19.4633L16.4165 20.8389Z"
          fill="#C147E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1195_475">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Office: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_1195_641)">
        <mask
          id="mask0_1195_641"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_641)">
          <path
            d="M33.9812 26.7188C33.4602 25.7873 32.5577 25.0873 31.4573 24.8467L27.3574 23.9503V22.9651"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0303 30.3125V36.0938H34.4678"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.1166 22.9721V23.9505L19.0376 24.8453C18.5683 24.9482 18.135 25.1348 17.752 25.3872"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.3568 23.9503L25.2365 29.6206L23.1162 23.9503"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.249 11.4785C22.7686 11.4785 20.7578 13.4893 20.7578 15.9697V17.0508H22.9537C24.4134 17.0508 25.7982 16.4045 26.7357 15.2857L29.7402 17.0508V15.9697C29.7402 13.4893 27.7294 11.4785 25.249 11.4785Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.7401 16.1685V18.9586C29.7401 21.4389 27.7293 23.4497 25.2489 23.4497C22.7685 23.4497 20.7578 21.4389 20.7578 18.9586V16.1685"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.2188 39.2188H0.78125V36.0938H39.2188V39.2188Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.78125 7.22988C0.78125 10.7914 3.66852 13.6787 7.23008 13.6787C10.7917 13.6787 13.6789 10.7914 13.6789 7.22988C13.6789 3.66832 10.7917 0.781055 7.23008 0.781055C3.66852 0.781055 0.78125 3.66832 0.78125 7.22988Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.23535 3.43748V7.23006L8.40324 8.39404"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.09375 17.7344H0.78125V30.2344H7.26562"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.0156 30.2344H17.6562V17.7344H12.3437"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.7812 33.2812H7.65625V25.5469C7.65625 24.6839 8.35578 23.9844 9.21875 23.9844C10.0817 23.9844 10.7812 24.6839 10.7812 25.5469V33.2812Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.2812 36.0938H5.15625V34.9219C5.15625 34.0158 5.89078 33.2812 6.79687 33.2812H11.6406C12.5467 33.2812 13.2812 34.0158 13.2812 34.9219V36.0938Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.2188 32.9688H39.2187V36.0938H29.2188V32.9688Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.2188 29.8438H39.2187V32.9688H29.2188V29.8438Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.2188 26.7188H39.2187V29.8438H29.2188V26.7188Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_641">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  GroceryBasket: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1195_989)">
        <mask
          id="mask0_1195_989"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_989)">
          <path
            d="M30.9375 34.0889C31.3687 34.0889 31.7187 34.4389 31.7187 34.8701C31.7187 35.3014 31.3687 35.6514 30.9375 35.6514C30.5062 35.6514 30.1562 35.3014 30.1562 34.8701C30.1562 34.4389 30.5062 34.0889 30.9375 34.0889Z"
            fill="#C147E9"
          />
          <path
            d="M17.9687 34.0889C18.4 34.0889 18.75 34.4389 18.75 34.8701C18.75 35.3014 18.4 35.6514 17.9687 35.6514C17.5375 35.6514 17.1875 35.3014 17.1875 34.8701C17.1875 34.4389 17.5375 34.0889 17.9687 34.0889Z"
            fill="#C147E9"
          />
          <path
            d="M21.0937 34.8701C21.0937 36.5959 19.6945 37.9951 17.9687 37.9951C16.243 37.9951 14.8438 36.5959 14.8438 34.8701C14.8438 33.1443 16.243 31.7451 17.9687 31.7451C19.6945 31.7451 21.0937 33.1443 21.0937 34.8701Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.0625 34.8701C34.0625 36.5959 32.6633 37.9951 30.9375 37.9951C29.2117 37.9951 27.8125 36.5959 27.8125 34.8701C27.8125 33.1443 29.2117 31.7451 30.9375 31.7451C32.6633 31.7451 34.0625 33.1443 34.0625 34.8701Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4156 23.9326L14.5187 28.6201H34.0625C34.925 28.6201 35.625 29.3201 35.625 30.1826C35.625 31.0451 34.925 31.7451 34.0625 31.7451H30.9375H17.9687H13.2812C12.5562 31.7451 11.9266 31.2459 11.7602 30.5404L5.79375 5.18262H2.34375C1.48125 5.18262 0.78125 4.48262 0.78125 3.62012C0.78125 2.75762 1.48125 2.05762 2.34375 2.05762H7.03125C7.75625 2.05762 8.38594 2.55684 8.55234 3.26231L10.475 11.4326L11.9453 17.6826L13.4156 23.9326Z"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
          />
          <path
            d="M10.4756 11.4326H17.4225H24.6881H31.9537H39.2193L37.6568 17.6826L36.3904 22.749C36.2161 23.4443 35.5911 23.9326 34.874 23.9326H30.3912H24.6881H18.985H13.4162"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6875 11.4326V14.5576"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6875 20.8076V23.9326"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.9531 11.4326L31.1719 17.6826L30.3906 23.9326"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4219 11.4326L18.2031 17.6826L18.9844 23.9326"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9453 17.6826H18.2031H21.5625"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.8125 17.6826H31.1719H37.6562"
            stroke="#C147E9"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6875 16.9014C25.1187 16.9014 25.4687 17.2514 25.4687 17.6826C25.4687 18.1139 25.1187 18.4639 24.6875 18.4639C24.2562 18.4639 23.9062 18.1139 23.9062 17.6826C23.9062 17.2514 24.2562 16.9014 24.6875 16.9014Z"
            fill="#C147E9"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_989">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Dumbell: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1195_1029)">
        <path
          d="M38.816 7.905L38.3614 7.45039L39.3114 6.50031C40.2291 5.58258 40.2291 4.08938 39.3114 3.17164L36.8293 0.689453C36.3847 0.244844 35.7937 0 35.165 0C34.5362 0 33.9452 0.244844 33.5006 0.689375L32.5504 1.63953L32.0958 1.18492C30.6004 -0.310469 28.1673 -0.310469 26.6718 1.18492L25.7236 2.13313L25.0965 1.50609C24.6432 1.05289 24.0407 0.803281 23.3996 0.803281C22.7586 0.803281 22.1561 1.05289 21.7028 1.50609L19.8084 3.40055C18.8728 4.33617 18.8728 5.85852 19.8084 6.79422L23.602 10.5878L19.3786 14.8112C19.0735 15.1163 19.0735 15.611 19.3786 15.9161C19.5311 16.0687 19.7311 16.1449 19.931 16.1449C20.1309 16.1449 20.3308 16.0686 20.4834 15.9161L24.7068 11.6927L28.308 15.2938L15.2946 28.3071L11.6935 24.7059L15.5116 20.8878C15.8167 20.5827 15.8167 20.088 15.5116 19.7829C15.2065 19.4779 14.712 19.4779 14.4067 19.7829L10.5886 23.601L6.79496 19.8075C6.34168 19.3542 5.7391 19.1046 5.09808 19.1046C4.45707 19.1046 3.85449 19.3542 3.40121 19.8075L1.50684 21.7019C0.571211 22.6376 0.571211 24.1599 1.50684 25.0955L2.13387 25.7226L1.18559 26.6709C-0.309805 28.1663 -0.309805 30.5995 1.18559 32.0949L1.64012 32.5495L0.690351 33.4997C0.24582 33.9442 0.000976562 34.5353 0.000976562 35.1641C0.000976562 35.7928 0.24582 36.3838 0.690351 36.8284L3.17254 39.3106C3.61707 39.7552 4.20816 40 4.83691 40C5.46566 40 6.05668 39.7552 6.50129 39.3106L7.45144 38.3605L7.90598 38.815C8.65371 39.5627 9.6359 39.9365 10.618 39.9365C11.6001 39.9365 12.5824 39.5627 13.33 38.815L14.2782 37.8668L14.9053 38.4938C15.3586 38.947 15.9611 39.1966 16.6021 39.1966C17.2432 39.1966 17.8457 38.947 18.299 38.4938L20.1934 36.5995C21.129 35.6638 21.129 34.1415 20.1934 33.2058L16.3998 29.4122L29.4132 16.3989L33.2067 20.1924C33.66 20.6457 34.2625 20.8953 34.9035 20.8953C35.5446 20.8953 36.1471 20.6457 36.6004 20.1924L38.4948 18.298C39.4304 17.3623 39.4304 15.84 38.4948 14.9044L37.8678 14.2773L38.8161 13.3291C40.3114 11.8336 40.3114 9.40047 38.816 7.905ZM5.39637 38.2057C5.39637 38.2058 5.39637 38.2058 5.39637 38.2057C5.24691 38.3552 5.04824 38.4375 4.83691 38.4375C4.62559 38.4375 4.42691 38.3552 4.27746 38.2057L1.79527 35.7235C1.64582 35.5741 1.56348 35.3754 1.56348 35.1641C1.56348 34.9527 1.64582 34.754 1.79527 34.6045L2.74535 33.6544L6.3466 37.2555L5.39637 38.2057ZM12.2251 37.7102C11.7959 38.1395 11.225 38.3759 10.618 38.3759C10.011 38.3759 9.44019 38.1395 9.0109 37.7102L2.29074 30.9901C1.40449 30.1039 1.40449 28.662 2.29074 27.7758L3.23902 26.8275L13.1733 36.7618L12.2251 37.7102ZM19.0885 35.4946L17.1941 37.389C16.8677 37.7155 16.3365 37.7155 16.0102 37.389L2.61199 23.9908C2.28551 23.6644 2.28559 23.1333 2.61199 22.8069L4.50637 20.9125C4.66441 20.7544 4.87473 20.6673 5.09832 20.6673C5.32191 20.6673 5.53223 20.7544 5.69027 20.9125L19.0884 34.3105C19.4148 34.637 19.4148 35.1681 19.0885 35.4946ZM34.6055 1.79422C34.755 1.64477 34.9536 1.5625 35.165 1.5625C35.3763 1.5625 35.575 1.64477 35.7244 1.7943L38.2066 4.27648C38.3561 4.42594 38.4384 4.62461 38.4384 4.83594C38.4384 5.04727 38.3561 5.24602 38.2066 5.39547L37.2565 6.34555L33.6553 2.74437L34.6055 1.79422ZM37.3898 17.1931L35.4954 19.0875C35.3374 19.2456 35.1271 19.3327 34.9035 19.3327C34.6799 19.3327 34.4696 19.2456 34.3115 19.0875L20.9134 5.68945C20.587 5.36305 20.587 4.83187 20.9134 4.50547L22.8078 2.61109C22.971 2.44789 23.1853 2.36625 23.3997 2.36625C23.6141 2.36625 23.8285 2.44781 23.9917 2.61109L37.3898 16.0092C37.7163 16.3356 37.7162 16.8667 37.3898 17.1931ZM37.7111 12.2241L36.7628 13.1724L26.8285 3.23813L27.7767 2.28992C28.206 1.86063 28.7768 1.62422 29.3838 1.62422C29.9908 1.62422 30.5617 1.86063 30.9909 2.28992L37.7111 9.01C38.5974 9.89602 38.5974 11.338 37.7111 12.2241Z"
          fill="currentColor"
        />
        <path
          d="M17.4453 18.6309C17.8768 18.6309 18.2266 18.2811 18.2266 17.8496C18.2266 17.4181 17.8768 17.0684 17.4453 17.0684C17.0138 17.0684 16.6641 17.4181 16.6641 17.8496C16.6641 18.2811 17.0138 18.6309 17.4453 18.6309Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1195_1029">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Bell: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2656 2.03125H22.7343C23.8086 2.03125 24.6875 2.91015 24.6875 3.98437C24.6875 5.05858 23.8086 5.93748 22.7343 5.93748H17.2656C16.1914 5.93748 15.3125 5.05858 15.3125 3.98437C15.3125 2.91007 16.1914 2.03125 17.2656 2.03125Z"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.70215 12.9546L9.70262 12.9549"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.2187 34.8438H0.78125V37.9687H39.2187V34.8438Z"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6249 34.4532V30.9375H4.375V34.4532"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 28.2031V30.5469M32.4999 30.5469V28.2031"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.39701 15.6089C5.97795 17.7276 5.15632 20.2253 5.15632 22.8931C5.15632 23.8581 4.65491 24.6874 3.59374 24.6874C2.73437 24.6874 2.03125 25.3906 2.03125 26.2499C2.03125 27.1093 2.73437 27.8124 3.59374 27.8124H36.4061C37.2655 27.8124 37.9686 27.1093 37.9686 26.2499C37.9686 25.3906 37.2655 24.6874 36.4061 24.6874C35.3451 24.6874 34.8436 23.8581 34.8436 22.8931C34.8436 15.2862 28.164 9.0625 19.9999 9.0625C17.3003 9.0625 14.7632 9.74312 12.576 10.9291"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8625 18.5973C28.0193 15.1541 24.0605 12.9688 20 12.9688"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5625 6.13281V8.86616M18.4375 8.86616V6.13281"
        stroke="currentColor"
        strokeWidth="1.56249"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Masks: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1195_1144)">
        <mask
          id="mask0_1195_1144"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M0 3.8147e-06H40V40H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_1144)">
          <path
            d="M5.70312 17.6562C5.70312 16.3617 6.75234 15.3125 8.04688 15.3125C9.34141 15.3125 10.3906 16.3617 10.3906 17.6562"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.0781 17.6562C15.0781 16.3617 16.1273 15.3125 17.4219 15.3125C18.7164 15.3125 19.7656 16.3617 19.7656 17.6562"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.3125 10.526V0.781494C15.3125 0.781494 20.7938 3.12524 27.2656 3.12524C33.7375 3.12524 39.2188 0.781494 39.2188 0.781494V20.0002C39.2188 26.472 33.7375 31.719 27.2656 31.719C26.225 31.719 25.0016 31.583 24.0219 31.3284C24.0102 31.3259 23.9984 31.3228 23.9867 31.3197"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.7344 31.7188C10.1453 31.7188 8.04688 29.6203 8.04688 27.0312V22.3438C10.6359 24.9328 14.8328 24.9328 17.4219 22.3438V27.0312C17.4219 29.6203 15.3234 31.7188 12.7344 31.7188Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.6094 8.28125C29.6094 9.57578 30.6586 10.625 31.9531 10.625C33.2477 10.625 34.2969 9.57578 34.2969 8.28125"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6875 23.1729C27.0492 22.2815 30.0523 22.787 31.9531 24.6877V20.0002C31.9531 17.4112 29.8547 15.3127 27.2656 15.3127C26.4117 15.3127 25.3773 15.5409 24.6875 15.9401"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.5625 18.4375C1.5625 18.8689 1.21266 19.2188 0.78125 19.2188C0.349766 19.2188 0 18.8689 0 18.4375C0 18.0061 0.349766 17.6563 0.78125 17.6563C1.21266 17.6563 1.5625 18.0061 1.5625 18.4375Z"
            fill="currentColor"
          />
          <path
            d="M0.78125 21.9531V27.5C0.78125 33.9719 6.2625 39.2188 12.7344 39.2188C17.8656 39.2188 22.3742 35.9203 24.0219 31.3281C24.4523 30.1281 24.6875 28.8406 24.6875 27.5V8.28125C24.6875 8.28125 20.5977 10.0297 15.3125 10.5062C14.4789 10.5812 13.6156 10.625 12.7344 10.625C6.2625 10.625 0.78125 8.28125 0.78125 8.28125V14.9218"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_1144">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Event: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1195_1200)">
        <mask
          id="mask0_1195_1200"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="-1"
          width="40"
          height="41"
        >
          <path d="M0 -0.000240326H40V39.9998H0V-0.000240326Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1195_1200)">
          <path
            d="M0.78125 32.4998H7.03125V30.9373C7.03125 30.0779 6.3282 29.3748 5.46875 29.3748H2.34375C1.48437 29.3748 0.78125 30.0779 0.78125 30.9373V32.4998Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.90625 13.7498C5.62742 13.7498 7.03125 12.3459 7.03125 10.6248C7.03125 8.90358 5.62742 7.49976 3.90625 7.49976C2.18508 7.49976 0.78125 8.90358 0.78125 10.6248C0.78125 12.3459 2.18508 13.7498 3.90625 13.7498Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.34375 29.3748V13.5156"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.46875 29.3748V13.5156"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.9688 32.4998H39.2187V30.9373C39.2187 30.0779 38.5156 29.3748 37.6562 29.3748H34.5312C33.6719 29.3748 32.9688 30.0779 32.9688 30.9373V32.4998Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.0937 13.7498C37.8149 13.7498 39.2187 12.3459 39.2187 10.6248C39.2187 8.90358 37.8149 7.49976 36.0937 7.49976C34.3726 7.49976 32.9688 8.90358 32.9688 10.6248C32.9688 12.3459 34.3726 13.7498 36.0937 13.7498Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.5312 29.3748V13.5156"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.6562 29.3748V13.5156"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.9478 1.34479L22.4054 4.02596L25.3523 4.54799C25.942 4.65096 26.3366 5.21244 26.2337 5.80221C26.1915 6.04369 26.0724 6.25237 25.906 6.40768L23.8498 8.57643L24.2642 11.5417C24.3461 12.1338 23.9326 12.6801 23.3405 12.762C23.1229 12.7921 22.9107 12.7568 22.7262 12.6688L19.9694 11.3555L17.28 12.6646C16.7418 12.9266 16.0929 12.7028 15.8309 12.1646C15.722 11.941 15.6971 11.6982 15.7437 11.4721L16.1307 8.52151L14.0521 6.36573C13.638 5.9351 13.6512 5.25034 14.0818 4.83612C14.2496 4.67479 14.456 4.5783 14.67 4.54612L17.6385 3.99448L19.0454 1.35315C19.3263 0.826742 19.9808 0.627524 20.5072 0.908305C20.7009 1.01159 20.8502 1.16549 20.9478 1.34479Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="2.613"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5316 23.5935H25.469L33.2817 39.2185H6.71875L14.5316 23.5935Z"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.4979 19.6994C13.0701 19.087 9.82951 17.5851 7.13897 15.3274C6.47826 14.7746 6.39084 13.7909 6.94365 13.1302C7.49647 12.4695 8.48022 12.382 9.14092 12.9349C12.192 15.4951 16.0176 16.8854 20.0001 16.8854C23.9828 16.8854 27.8083 15.4951 30.8594 12.9349C31.5201 12.382 32.5039 12.4695 33.0567 13.1302C33.6095 13.7909 33.5221 14.7746 32.8614 15.3274C30.1708 17.5852 26.9298 19.0871 23.5019 19.6995"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="22.926"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 20.0105H20.0005"
            stroke="currentColor"
            strokeWidth="1.5625"
            strokeMiterlimit="2.613"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1195_1200">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Manufactoring: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1195_1241)">
        <path
          d="M39.9977 19.4849L38.6494 1.05797C38.6149 0.588203 38.2238 0.224609 37.7528 0.224609H31.5505C31.0812 0.224609 30.6909 0.585703 30.6544 1.05352L29.3099 18.2804L20.5184 12.0746C20.2439 11.881 19.8845 11.8563 19.5864 12.0109C19.2883 12.1654 19.1011 12.4731 19.1011 12.809V17.8158L10.9678 12.0745C10.6934 11.8809 10.334 11.8562 10.0359 12.0108C9.73781 12.1653 9.55062 12.473 9.55062 12.8089V17.8157L1.41727 12.0745C1.14289 11.8809 0.783437 11.8562 0.485391 12.0108C0.187266 12.1653 0 12.4731 0 12.8089V38.8763C0 39.3728 0.402422 39.7752 0.898906 39.7752H39.1012C39.5975 39.7752 40.0001 39.3728 40.0001 38.8763V19.5505C40 19.5391 39.9984 19.4956 39.9977 19.4849ZM32.382 2.02242H36.9174L37.4403 9.16891H31.8243L32.382 2.02242ZM31.684 10.9666H37.5718L37.7544 13.4609H37.0256C36.5293 13.4609 36.1267 13.8634 36.1267 14.3598C36.1267 14.8563 36.5292 15.2587 37.0256 15.2587H37.8859L38.1341 18.6516H31.0841L31.684 10.9666ZM7.96227 37.9774H5.39328V26.7415H7.96227V37.9774ZM12.329 37.9774H9.76V26.7415H12.329V37.9774ZM38.2022 37.9774H14.1267V25.8426C14.1267 25.3461 13.7243 24.9437 13.2278 24.9437H4.49438C3.99789 24.9437 3.59547 25.3461 3.59547 25.8426V37.9774H1.79773V14.5437L9.93102 20.2849C10.2052 20.4784 10.5648 20.503 10.8629 20.3487C11.161 20.1941 11.3482 19.8864 11.3482 19.5505V14.5437L19.4815 20.2849C19.7557 20.4784 20.1151 20.503 20.4134 20.3487C20.7115 20.1941 20.8988 19.8864 20.8988 19.5505V14.5437L29.032 20.2849C29.1837 20.392 29.3647 20.4495 29.5504 20.4495H30.1114C30.1116 20.4495 30.112 20.4495 30.1122 20.4495H38.2021V37.9774H38.2022Z"
          fill="currentColor"
        />
        <path
          d="M33.9283 13.4609H33.8384C33.342 13.4609 32.9395 13.8634 32.9395 14.3598C32.9395 14.8563 33.342 15.2588 33.8384 15.2588H33.9283C34.4246 15.2588 34.8272 14.8563 34.8272 14.3598C34.8271 13.8634 34.4246 13.4609 33.9283 13.4609Z"
          fill="currentColor"
        />
        <path
          d="M15.9248 23.146V27.4157C15.9248 27.9121 16.3272 28.3146 16.8237 28.3146H35.506C36.0023 28.3146 36.4049 27.9121 36.4049 27.4157V23.146C36.4049 22.6496 36.0025 22.2471 35.506 22.2471H16.8236C16.3272 22.2471 15.9248 22.6495 15.9248 23.146ZM30.1774 24.0448H34.6071V26.5167H30.1774V24.0448ZM23.95 24.0448H28.3796V26.5167H23.95V24.0448ZM17.7225 24.0448H22.1522V26.5167H17.7225V24.0448Z"
          fill="currentColor"
        />
        <path
          d="M35.506 30.1123H16.8237C16.3272 30.1123 15.9248 30.5147 15.9248 31.0112V35.2809C15.9248 35.7774 16.3272 36.1798 16.8237 36.1798H35.506C36.0023 36.1798 36.4049 35.7774 36.4049 35.2809V31.0112C36.4049 30.5148 36.0024 30.1123 35.506 30.1123ZM22.1522 34.382H17.7225V31.9101H22.1522V34.382ZM28.3796 34.382H23.95V31.9101H28.3796V34.382ZM34.6071 34.382H30.1774V31.9101H34.6071V34.382Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1195_1241">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Announcement: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
    >
      <path
        d="M23.7214 9.50579V46.6124C23.7206 47.7637 23.3135 48.8779 22.5718 49.7585C21.8301 50.6391 20.8014 51.2297 19.667 51.4262C18.5326 51.6227 17.3652 51.4126 16.3704 50.8328C15.3757 50.2531 14.6176 49.3409 14.2295 48.2569L8.26542 31.1731M8.26542 31.1731C5.90762 30.1706 3.96858 28.3871 2.77645 26.1192C1.58432 23.8514 1.21231 21.2414 1.72338 18.7308C2.23445 16.2202 3.59721 13.9633 5.58104 12.342C7.56486 10.7207 10.0479 9.83455 12.61 9.83357H17.699C29.0882 9.83357 38.8802 6.4057 43.1664 1.5V40.39C38.8802 35.4843 29.091 32.0564 17.699 32.0564H12.61C11.1173 32.0586 9.63949 31.7563 8.26542 31.1731ZM43.1664 29.2786C45.3766 29.2786 47.4963 28.4006 49.0592 26.8377C50.622 25.2749 51.5 23.1552 51.5 20.945C51.5 18.7348 50.622 16.6151 49.0592 15.0523C47.4963 13.4894 45.3766 12.6114 43.1664 12.6114"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Stars: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
    >
      <path
        d="M7.05556 1.5V12.6111M1.5 7.05556H12.6111M9.83333 40.3889V51.5M4.27778 45.9444H15.3889M29.2778 1.5L35.6278 20.5472L51.5 26.5L35.6278 32.4528L29.2778 51.5L22.9278 32.4528L7.05556 26.5L22.9278 20.5472L29.2778 1.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Clock: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53 53"
      fill="none"
    >
      <path
        d="M26.5 15.3889V26.5L34.8333 34.8333M51.5 26.5C51.5 29.783 50.8534 33.0339 49.597 36.0671C48.3406 39.1002 46.4991 41.8562 44.1777 44.1777C41.8562 46.4991 39.1002 48.3406 36.0671 49.597C33.0339 50.8534 29.783 51.5 26.5 51.5C23.217 51.5 19.9661 50.8534 16.9329 49.597C13.8998 48.3406 11.1438 46.4991 8.82233 44.1777C6.50087 41.8562 4.65938 39.1002 3.40301 36.0671C2.14664 33.0339 1.5 29.783 1.5 26.5C1.5 19.8696 4.13392 13.5107 8.82233 8.82233C13.5107 4.13392 19.8696 1.5 26.5 1.5C33.1304 1.5 39.4893 4.13392 44.1777 8.82233C48.8661 13.5107 51.5 19.8696 51.5 26.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  BookOpen: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 47"
      fill="none"
    >
      <path
        d="M29 5.32861V45.0508M29 5.32861C25.4311 2.9575 20.585 1.5 15.25 1.5C9.915 1.5 5.06889 2.9575 1.5 5.32861V45.0508C5.06889 42.6797 9.915 41.2222 15.25 41.2222C20.585 41.2222 25.4311 42.6797 29 45.0508M29 5.32861C32.5689 2.9575 37.415 1.5 42.75 1.5C48.0881 1.5 52.9311 2.9575 56.5 5.32861V45.0508C52.9311 42.6797 48.0881 41.2222 42.75 41.2222C37.415 41.2222 32.5689 42.6797 29 45.0508"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Playlist: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 40"
      fill="none"
    >
      <g clipPath="url(#clip0_1373_834)">
        <path
          d="M27.5585 2.23129H2.06828C1.80827 2.23129 1.5589 2.128 1.37504 1.94414C1.19118 1.76028 1.08789 1.51092 1.08789 1.2509C1.08789 0.990884 1.19118 0.741517 1.37504 0.557658C1.5589 0.373799 1.80827 0.270508 2.06828 0.270508H27.5585C27.8185 0.270508 28.0679 0.373799 28.2517 0.557658C28.4356 0.741517 28.5389 0.990884 28.5389 1.2509C28.5389 1.51092 28.4356 1.76028 28.2517 1.94414C28.0679 2.128 27.8185 2.23129 27.5585 2.23129Z"
          fill="currentColor"
        />
        <path
          d="M27.5585 12.035H2.06828C1.80827 12.035 1.5589 11.9317 1.37504 11.7479C1.19118 11.564 1.08789 11.3146 1.08789 11.0546C1.08789 10.7946 1.19118 10.5452 1.37504 10.3614C1.5589 10.1775 1.80827 10.0742 2.06828 10.0742H27.5585C27.8185 10.0742 28.0679 10.1775 28.2517 10.3614C28.4356 10.5452 28.5389 10.7946 28.5389 11.0546C28.5389 11.3146 28.4356 11.564 28.2517 11.7479C28.0679 11.9317 27.8185 12.035 27.5585 12.035Z"
          fill="currentColor"
        />
        <path
          d="M15.7938 21.8392H2.06828C1.80827 21.8392 1.5589 21.7359 1.37504 21.5521C1.19118 21.3682 1.08789 21.1188 1.08789 20.8588C1.08789 20.5988 1.19118 20.3494 1.37504 20.1656C1.5589 19.9817 1.80827 19.8784 2.06828 19.8784H15.7938C16.0538 19.8784 16.3032 19.9817 16.487 20.1656C16.6709 20.3494 16.7742 20.5988 16.7742 20.8588C16.7742 21.1188 16.6709 21.3682 16.487 21.5521C16.3032 21.7359 16.0538 21.8392 15.7938 21.8392Z"
          fill="currentColor"
        />
        <path
          d="M15.7938 31.6429H2.06828C1.80827 31.6429 1.5589 31.5396 1.37504 31.3558C1.19118 31.1719 1.08789 30.9225 1.08789 30.6625C1.08789 30.4025 1.19118 30.1531 1.37504 29.9693C1.5589 29.7854 1.80827 29.6821 2.06828 29.6821H15.7938C16.0538 29.6821 16.3032 29.7854 16.487 29.9693C16.6709 30.1531 16.7742 30.4025 16.7742 30.6625C16.7742 30.9225 16.6709 31.1719 16.487 31.3558C16.3032 31.5396 16.0538 31.6429 15.7938 31.6429Z"
          fill="currentColor"
        />
        <path
          d="M21.6767 39.4859C21.5479 39.486 21.4204 39.4607 21.3014 39.4114C21.1825 39.3622 21.0744 39.2899 20.9833 39.1989C20.8923 39.1078 20.8201 38.9998 20.7708 38.8808C20.7216 38.7618 20.6962 38.6343 20.6963 38.5056V18.8977C20.6962 18.7227 20.7429 18.5509 20.8317 18.4002C20.9205 18.2494 21.048 18.1251 21.201 18.0403C21.354 17.9555 21.527 17.9132 21.7019 17.9178C21.8768 17.9225 22.0473 17.9739 22.1956 18.0667L37.8819 27.8706C38.0231 27.9585 38.1395 28.0809 38.2202 28.2263C38.301 28.3717 38.3434 28.5353 38.3434 28.7016C38.3434 28.8679 38.301 29.0315 38.2202 29.1769C38.1395 29.3223 38.0231 29.4448 37.8819 29.5327L22.1956 39.3366C22.0402 39.4344 21.8603 39.4862 21.6767 39.4859ZM22.6571 20.667V36.7363L35.5132 28.7016L22.6571 20.667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1373_834">
          <rect width="38.8235" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Growth: (props: IconProps) => (
    <svg
      aria-label="Icon"
      role="img"
      className={classnames(props)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 25"
      fill="none"
    >
      <path
        d="M23.2222 1H41M41 1V18.7778M41 1L23.2222 18.7778L14.3333 9.88889L1 23.2222"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}

export const IconComponent = ({
  icon,
  size = 'base',
  color = 'primary',
  className,
}: {
  icon: keyof typeof Icon
  size?: 'xxsmall' | 'xsmall' | 'small' | 'base' | 'medium' | 'large' | 'xlarge'
  color?: 'primary' | 'secondary' | 'success' | 'danger'
  className?: string
}) => {
  const IconToRender = mapNameToIcon(icon)

  if (!IconToRender) {
    return null
  }

  return <IconToRender size={size} color={color} className={cn('shrink-0', className)} />
}

const mapNameToIcon = (name: string) => {
  const icon = Icon[name as keyof typeof Icon]

  if (!icon) {
    return null
  }

  return icon
}

export default Icon
